
import { takeLatest, put, call, select } from "redux-saga/effects";
import { reset, change, initialize } from "redux-form";
import { firebaseAuthentication, firebaseDatabase } from "../../controller/firebase";
import { saveInSession, logout, getFromSession } from "../../controller/session";
import XlsxPopulate from "xlsx-populate";
import * as XLSX from 'xlsx';
import { saveAs } from "file-saver";

import axios from "axios";
import React, { Component } from "react";
import { ACTIONS_OF_APROVE, ACTIONS_ON_AFILIATE_RYA, ACTION_AFILIATE_COMPANY, ANULACION_FORM_NAME, convertionState, DEVOLUCIONES_FORM_NAME, HEADERS_WS, OBTENER_DATA_REG_EMPRESAS, PAGINAR_DATA_REG_EMPRESAS, REDUX_BLUR, REDUX_CHANGE, REQUIRED_DATOS_DEVOLUCION, RETURN_HOME_BANDEJA, SAVED_ACTIONS_VALIDATION, SEARCH_FORM_FROM_TABLE, SEARCH_HISTORIAL_BANDEJA, VALIDATE_USER_TYPE, HEADER_TABLE_PAGINATOR_EMPRESAS, EXPORT_DATA_FORM_XLSX, PAGINAR_DATA_REPORTS, OBTENER_DATA_REPORTS, OPEN_REPORT_COMPLETION, INIT_SEARCH_FILTER_REPORT, OPEN_COMPONENT_INFORMES, REPORTS_FORM_NAME, OPEN_MODAL_DESCARGAR_DATOS, DOWMLOAD_DATA_TABLE_AFILIATIONS, HEADER_TABLE_PAGINATOR_REPORTS, INIT_CHARGE_CATALOG, REGISTRO_AND_APORTES_FORM_NAME, ACTION_ANULATION_FORM, FORM_NAME_ANULATION_FORM, OPEN_ANULATION_FORM, ANULACION_FORM_NAME_V2 } from "./constants";
import { callDinamicDisableLote, closeModales, dataAnulationForm, dataModalDescarDatos, errorGeneral, initOpenComponentReports, loadDocumentSuccess, messageAlertSend, messageAnulationFormRya, messageConfirmationSend, ocultarDevoluciones, openFormBandeja, openHistoryBandeja, openModalCharged, returnHomeBandeja, saveConsultaReports, savedInfoUserBandeja, sendMessageConfirmationRya, setDataPaginarRegEmpresas, setDataPaginarReportsEmpresas, typeUserBandeja, updateMsgSolicitud, validateUserTypeSuccess } from "./actions";
import { getConsultaReports, getDataAnulationForm, getDynamicOptions, getFormValuesAnulacion, getFormValuesAnulacionFormMotivo, getFormValuesAnulationForm, getFormValuesDevolucion, getFormValuesFilter, getFormValuesRyaForm, getIdFormulario, getIdUsuaAsesor, getMsgParametrizados, getSuc_id, getTotalConsultaReports, getUserInfo, getUserType } from "./selector";
import { consultaMsgParametrizado, convNumFormat, convertStringToDate, createState, dataRnecToAfiliacion, emptyObject, enviarEmailFormatDocument, existLabel, getAsyncCatalog, getAsyncCatalogV2, getAsyncUserRolFirebase, getFechaOfDate, getFechaOfDateRya, getFechaOfDateV2, getFechaOfDateV4, getFechaOfDateYearMonth, manejoDeexepciones, notificaFalloWBS, ordenar, primeraMayuscula, retornaIdCatalog, returnDataCatalog, returnDataCatalogV2, returnDataCatalogV3, saveBdWebService, saveHistoryEmpresas } from "../../controller/utils";
import { estados } from "../../controller/constants";



function* generarQueryConsultaPaginada(reference, first, fecha, nextPage, rows) {
    /*
    función que genera la consulta paginada que se ejecuta sobre firebase para traer los 
    datos de la tabla principal de bandeja de comercial y rya
    */
    let consulta = reference
    if (first == 0) {
        if (fecha) {
            consulta = reference.limit(rows)
        } else if (!nextPage) {
            consulta = reference.limit(rows)
        } else {
            consulta = false
        }

    } else if (first > 0) {
        if (nextPage) {
            consulta = reference.startAfter(fecha).limit(rows)
        } else {
            consulta = reference.endBefore(fecha).limitToLast(rows)
        }
    }
    return consulta;
}

function convertirFecha(fecha) {
    const fech = fecha.toDate();
    const mm = (fech.getMonth() + 1)
    const dd = (fech.getDate());
    const hh = (fech.getHours());
    const mmh = (fech.getMinutes());
    const ssh = (fech.getSeconds());
    return `${dd > 9 ? "" + dd : "0" + dd}/${mm > 9 ? "" + mm : "0" + mm}/${fech.getFullYear()} ${hh > 9 ? "" + hh : "0" + hh}:${mmh > 9 ? "" + mmh : "0" + mmh}:${ssh > 9 ? "" + ssh : "0" + ssh}`;
}

function convertirState(state) {
    return convertionState[state.toString()];
}

function* crearDataTable(action) {
    /*
    Función que genera las tablas con respecto a la información dada 
    respecto a el tipo de coleccion que se le pasa, se usa para la tabla de bandeja y la tabla de informes
    */

    const { data, coleccion } = action;
    const datos = [];
    try {
        if (data.length > 0) {
            const sedes = yield getAsyncCatalog('SEDES_REGIONALES');
            let catalog = yield select(getDynamicOptions);
            if (!catalog) {
                yield put(loadDocumentSuccess({ sedes }));
            } else {
                catalog.sedes = sedes;
                yield put(loadDocumentSuccess(catalog));
            }

            if (coleccion === "regCompany") {

                for (var i of data) {
                    const typeCompany = emptyObject(i.stepPrincipal.afiliacionEmpresas.empleadorTypeCompany) === "1" ? "Persona Jurídica" : emptyObject(i.stepPrincipal.afiliacionEmpresas.empleadorTypeCompany) === "2" ? "Persona Natural" : "Servicio Doméstico";

                    //validamos quien abrio la postulacion 
                    let dateValidation = "";
                    if (i.validRya) {
                        dateValidation = convertirFecha(i.validRya.fechaFin);
                    } else if (i.validComercial) {
                        dateValidation = convertirFecha(i.validComercial.fechaFin);
                    } else if (i.dateValidation) {
                        dateValidation = convertirFecha(i.dateValidation);
                    }

                    datos.push({
                        dateRegister: i.dateFirma ? convertirFecha(i.dateFirma) : convertirFecha(i.date),
                        dateReSend: i.dateReenvio ? convertirFecha(i.dateReenvio) : "",
                        procesoNum: emptyObject(i.step2?.datosempleador?.processNumber),
                        idDocu: emptyObject(i.idDocu),
                        sucursalId: returnDataCatalog(sedes, i.step0.datosinicio.sedeRegional, "value", "label"),
                        companyType: typeCompany,
                        company: emptyObject(i.step0?.datosinicio?.employerNameStart).toUpperCase(),
                        nitCompany: `${emptyObject(i.stepPrincipal.afiliacionEmpresas.typeIdCompanyGes)} - ${emptyObject(i.step0?.datosinicio?.checkNumberStart)}`,
                        generateBy: emptyObject(i.asistido?.asesor) ? "Asistido" : "Cliente",
                        state: convertirState(i.state),
                        dateValida: dateValidation,
                        dateDevolved: i.devolucion && i.devolucion.fecha ? convertirFecha(i.devolucion.fecha) : "",
                        numDocBD: i.numDocBD,
                        validRya: i.validRya ? { ...i.validRya } : false,
                        validComercial: i.validComercial ? { ...i.validComercial } : false,
                        validEjecutivo: i.validEjecutivo ? { ...i.validEjecutivo } : false,
                        ticketAfiliacion: i.ticketAfiliacion ? i.ticketAfiliacion : "",
                    })
                }
            }

            if (coleccion === "reportsCompany") {

                for (var i of data) {
                    const typeCompany = emptyObject(i.tipoEmpleador) === 1 ? "Persona Jurídica" : emptyObject(i.tipoEmpleador) === 2 ? "Persona Natural" : "Servicio Doméstico";
                    const auxState = yield returnDataCatalogV2(catalog.states, parseInt(i.estado), "value", "label");

                    datos.push({

                        nroOportunidad: emptyObject(i.idOportunidad),
                        dateCreate: getFechaOfDateV4(emptyObject(i.fechaCreacion?.value)),
                        dateModifica: getFechaOfDateV4(emptyObject(i.fechaModificacion?.value)),
                        dateSend: getFechaOfDateV4(emptyObject(i.fechaFirma?.value)),
                        dateReSend: getFechaOfDateV4(emptyObject(i.fechaReenvio?.value)),
                        idDocu: emptyObject(i.idDocu),
                        state: `${primeraMayuscula(auxState.toLowerCase())}`,
                        idCompany: emptyObject(i.idCompany),
                        razonSocial: emptyObject(i.razonSocial),
                        empleadorType: typeCompany,
                        nroEmployer: emptyObject(i.numeroEmpleados),
                        dateValidCmr: i.fechaFinValidaComercial?.value ? getFechaOfDateV4(emptyObject(i.fechaFinValidaComercial?.value)) : getFechaOfDateV4(emptyObject(i.fechaValidaComercial?.value)),
                        userValidCmr: emptyObject(i.userValidComercial),
                        dateValidaRya: i.fechaFinValidaRya?.value ? getFechaOfDateV4(emptyObject(i.fechaFinValidaRya?.value)) : getFechaOfDateV4(emptyObject(i.fechaValidaRya?.value)),
                        userValidaRya: emptyObject(i.usuarioValidaRya),
                        dateAfilia: getFechaOfDateV4(emptyObject(i.fechaAfiliacion?.value)),
                        userAfilia: emptyObject(i.userAfilia),
                        dateDevolCmr: getFechaOfDateV4(emptyObject(i.fechaDevolucion?.value)),
                        userDevolCmr: emptyObject(i.userDevol),
                        motivoDevolCmr: emptyObject(i.motivoDevol),
                        obsDevolCmr: emptyObject(i.observacionDevol),
                        dateDevolRya: getFechaOfDateV4(emptyObject(i.fechaDevolucionComercial?.value)),
                        userDevolRya: emptyObject(i.userDevolCmr),
                        motivoDevolRya: emptyObject(i.motivoDevolCmr),
                        obsDevolRya: emptyObject(i.observacionDevolCmr),
                        dateAnula: getFechaOfDateV4(emptyObject(i.fechaAnulacion?.value)),
                        userAnula: emptyObject(i.userAnula),
                        motivoAnula: emptyObject(i.motivoAnulacion),
                        obsAnula: emptyObject(i.observacionAnulacion),
                        idFirebase: emptyObject(i.id),
                    })
                }
            }
        }
        return datos;//.sort(ordenarFecha);


    } catch (error) {
        throw error;
    }
}

function* generateMsgParametrizado(catalog, clave) {
    try {
        const message = yield consultaMsgParametrizado(catalog, clave);
        yield put(updateMsgSolicitud(message));
        return message.text;
    } catch (error) {
        throw error;
    }
}

function* paginarDataRegCompany(action) {
    /*
    función que realiza la consulta paginada de la tabla principal de bandeja de comercial y rya
    obedece al evento del usuario
*/
    try {
        let reference = false;
        let data = false;

        const { first, rows } = action.value.event;
        const { ultimaConv, nextPage } = action.value;


        let ultimaConvFecha = convertStringToDate(ultimaConv.dateRegister)

        const userType = yield select(getUserType);
        const suc_id = yield select(getSuc_id)
        if (userType === 'rya') {
            reference = yield firebaseDatabase.collection(process.env.REACT_APP_FIREBASE_COLECCION_COMPANY)
                .where('state', "in", [estados.APROBADA, estados.VALIDACION_RYA])
                .orderBy('date', 'asc')
        } else if (userType === "comercial") {
            if (suc_id === "1")
                reference = yield firebaseDatabase.collection(process.env.REACT_APP_FIREBASE_COLECCION_COMPANY)
                    .where('state', "in", [estados.FIRMADA_SIN_ASESOR, estados.APROBADA_CORPORATIVO, estados.VALIDACION_COMERCIAL, estados.DEVUELTA_COMERCIAL])
                    .orderBy('date', 'asc')
            else
                reference = yield firebaseDatabase.collection(process.env.REACT_APP_FIREBASE_COLECCION_COMPANY)
                    .where('state', "in", [estados.FIRMADA_SIN_ASESOR, estados.APROBADA_CORPORATIVO, estados.VALIDACION_COMERCIAL, estados.DEVUELTA_COMERCIAL])
                    .where("step0.datosinicio.sedeRegional", "==", suc_id)
                    .orderBy('date', 'asc')
        } else if (userType === "ejecutivoCorporativo") {
            //const idUsua = yield select(getIdUsuaAsesor);
            const asesorEmail = yield select(getUserInfo);
            const emailMin = asesorEmail.email.toLowerCase();
            reference = yield firebaseDatabase.collection(process.env.REACT_APP_FIREBASE_COLECCION_COMPANY)
                .where('state', "in", [estados.FIRMADA, estados.VALIDACION_CORPORATIVO])
                //.where("step0.datosinicio.sedeRegional", "==", suc_id)
                .where("asesorAsigna.email", "==", `${emailMin}`)
                .orderBy('date', 'asc')
        }

        //const snapshot = yield firebaseDatabase.collection(process.env.REACT_APP_FIREBASE_COLECCION_COMPANY).doc("ER6KprrabX4yKIf4oC9d");
        let query = yield generarQueryConsultaPaginada(reference, first, ultimaConvFecha, nextPage, rows);

        let resultadoConsulta = []
        let esPrimeraPagina = false;


        if (query) {

            yield query.get().then(response => {
                response.docs.map((doc, i) => {
                    let dataAfilia = doc.data();
                    dataAfilia.numDocBD = doc.id;
                    resultadoConsulta.push(dataAfilia)
                });

            })

            const dataFinal = resultadoConsulta;

            data = yield crearDataTable({ data: dataFinal, coleccion: "regCompany" });


        } else {
            esPrimeraPagina = true
        }

        yield put(setDataPaginarRegEmpresas(
            {
                "dataPaginada": data,
                "esPrimeraPagina": esPrimeraPagina
            }
        ));
    } catch (error) {
        console.error("saga.paginarDataRegCompany", error);
        yield put(errorGeneral(manejoDeexepciones(error)));
    }

}

function getSheetData(data, header) {
    /*
función que realiza el mapeo de la información para crear el archivo excel
*/
    try {

        var fields = Object.keys(data[0]);
        var sheetData = data.map(function (row) {
            return fields.map(function (fieldName) {
                return row[fieldName] ? row[fieldName] : "";
            });
        });
        sheetData.unshift(header);
        return sheetData;
    } catch (error) {
        throw error;
    }
}

function* exportIntentToExcel(action) {
    /*
función que genera el archivo excel de la tabla bandeja
*/
    try {

        const { value: { dataToDownloadCsv } } = action;
        const jsonToExcel = dataToDownloadCsv;

        if (jsonToExcel.length > 0) {

            const header = []
            HEADER_TABLE_PAGINATOR_EMPRESAS.forEach(e => {
                header.push(e.header)
            });

            XlsxPopulate.fromBlankAsync().then(async (workbook) => {
                const sheet1 = workbook.sheet(0);
                const sheetData = getSheetData(jsonToExcel, header);
                const totalColumns = sheetData[0].length;

                sheet1.cell("A1").value(sheetData);
                const range = sheet1.usedRange();
                const endColumn = String.fromCharCode(64 + totalColumns);
                sheet1.row(1).style("bold", true);
                sheet1.range("A1:" + endColumn + "1").style("fill", "BFBFBF");
                range.style("border", true);
                return workbook.outputAsync().then((res) => {
                    saveAs(res, "InscripcionesEmpresas.xlsx");
                });
            });

        }


    } catch (error) {
        yield put(errorGeneral(manejoDeexepciones(error)));
    }
}

function* obtenerDatosRegCompany(action, limit = 10) {
    /*
función que genera la tabla con las afiliaciones directamente al iniciar sesion de colaboradores
*/
    try {
        const { suc_id } = action;

        let reference;
        //vamos a consultar los primeros 10 registros de empresas
        let resultadoConsulta = []
        const userType = yield select(getUserType);
        let referenceTwo;

        if (userType === 'rya') {
            reference = yield firebaseDatabase.collection(process.env.REACT_APP_FIREBASE_COLECCION_COMPANY)
                .where('state', "in", [estados.APROBADA, estados.VALIDACION_RYA])
                // .where("step0.datosinicio.sedeRegional", "==", suc_id)
                .orderBy('date', 'asc').limit(limit)
                .get();
        } else if (userType === "comercial") {
            if (suc_id === "1")
                reference = yield firebaseDatabase.collection(process.env.REACT_APP_FIREBASE_COLECCION_COMPANY)
                    .where('state', "in", [estados.FIRMADA_SIN_ASESOR, estados.APROBADA_CORPORATIVO, estados.VALIDACION_COMERCIAL, estados.DEVUELTA_COMERCIAL])
                    .orderBy('date', 'asc').limit(limit)
                    .get();


            else
                reference = yield firebaseDatabase.collection(process.env.REACT_APP_FIREBASE_COLECCION_COMPANY)
                    .where('state', "in", [estados.FIRMADA_SIN_ASESOR, estados.APROBADA_CORPORATIVO, estados.VALIDACION_COMERCIAL, estados.DEVUELTA_COMERCIAL])
                    .where("step0.datosinicio.sedeRegional", "==", suc_id)
                    //.where("idUsua", "==", "5646")
                    .orderBy('date', 'asc').limit(limit)
                    .get();
        } else if (userType === "ejecutivoCorporativo") {
            //const idUsua = yield select(getIdUsuaAsesor);
            const asesorEmail = yield select(getUserInfo);
            const emailMin = asesorEmail.email.toLowerCase();

            reference = yield firebaseDatabase.collection(process.env.REACT_APP_FIREBASE_COLECCION_COMPANY)
                .where('state', "in", [estados.FIRMADA, estados.VALIDACION_CORPORATIVO])
                //.where("step0.datosinicio.sedeRegional", "==", suc_id)
                // .where("idUsuaAsesor", "==", `${idUsua}`)
                .where("asesorAsigna.email", "==", `${emailMin}`)
                .orderBy('date', 'asc').limit(limit)
                .get();

            // referenceTwo = yield firebaseDatabase.collection(process.env.REACT_APP_FIREBASE_COLECCION_COMPANY)
            //     .where('state', "in", [estados.FIRMADA, estados.VALIDACION_COMERCIAL, estados.DEVUELTA_COMERCIAL])
            //     //.where("step0.datosinicio.sedeRegional", "==", suc_id)
            //     .where("step0.datosinicio.sedeRegional", "==", suc_id)
            //     .orderBy('date', 'asc').limit(limit)
            //     .get();
        }

        if (reference) {
            reference.docs.map((doc, i) => {
                let dataAfilia = doc.data();
                dataAfilia.numDocBD = doc.id;
                resultadoConsulta.push(dataAfilia)
            });

            if (userType === "ejecutivoCorporativo" && referenceTwo) {
                let auxDataTwo = [];
                referenceTwo.docs.map((doc, i) => {
                    let dataAfilia = doc.data();
                    dataAfilia.numDocBD = doc.id;
                    auxDataTwo.push(dataAfilia)
                });
                const allDocs = [...resultadoConsulta, ...auxDataTwo];
                const uniqueDocs = Array.from(new Set(allDocs.map(doc => doc.numDocBD))).map(id =>
                    allDocs.find(doc => doc.numDocBD === id)
                );

                // uniqueDocs.forEach(doc => {
                console.log(uniqueDocs);
                // });

                resultadoConsulta = [...uniqueDocs]

            }
        }
        if (resultadoConsulta.length > 0) {

            const dataFinal = resultadoConsulta;

            let data = yield crearDataTable({ data: dataFinal, coleccion: "regCompany" });

            yield put(setDataPaginarRegEmpresas(
                {
                    "dataRegCompany": data,
                    "esPrimeraPagina": true
                }
            ));
        } else {
            // no hay afiliaciones para esa sucursal a la que pertenece
            yield put(setDataPaginarRegEmpresas(
                {
                    "dataRegCompany": [],
                    "esPrimeraPagina": true
                }
            ));
        }

    } catch (error) {
        console.error('saga.obtenerDatosRegCompany', error);
        yield put(errorGeneral(manejoDeexepciones(error)));
    }
}

function* searchFormFromTable(action) {
    /*
función que abre la postulación correspondiente a la seleccion del asesor
*/
    try {
        const { value: { numDocBD, validComercial, validEjecutivo, validRya } } = action;

        yield put(openFormBandeja({ state: true, idForm: numDocBD }));
        const userInfo = yield select(getUserInfo);
        const userType = yield select(getUserType);
        yield buildDynamicOptions({ userType });
        const history = {
            fechaHistory: new Date(),
            tomado: userInfo.rol,
            infoUsuario: userInfo,
            resultadoValidacion: {
                fechaValidacion: new Date(),
                accionRealizada: "Revisado por asesor"
            },
        }

        saveHistoryEmpresas({ history, idFormulario: numDocBD })
        if (userType === "comercial" || userType === "ejecutivoCorporativo") {
            if (userType === "ejecutivoCorporativo") {
                const validEjec = {
                    fechaIni: !validEjecutivo ? history.fechaHistory : validEjecutivo.fechaIni,
                    user: userInfo,
                    fechaFin: !validEjecutivo ? history.fechaHistory : new Date(),
                }
                yield firebaseDatabase.collection(process.env.REACT_APP_FIREBASE_COLECCION_COMPANY)
                    .doc(numDocBD).set({ state: estados.VALIDACION_CORPORATIVO, validEjecutivo: validEjec, date: validEjec.fechaFin }, { merge: true });

            } else {
                const validCmr = {
                    fechaIni: !validComercial ? history.fechaHistory : validComercial.fechaIni,
                    user: userInfo,
                    fechaFin: !validComercial ? history.fechaHistory : new Date(),
                }
                yield firebaseDatabase.collection(process.env.REACT_APP_FIREBASE_COLECCION_COMPANY)
                    .doc(numDocBD).set({ state: estados.VALIDACION_COMERCIAL, validComercial: validCmr, date: validCmr.fechaFin }, { merge: true });
            }
        }
        else {
            const validRy = {
                fechaIni: !validRya ? history.fechaHistory : validRya.fechaIni,
                user: userInfo,
                fechaFin: !validRya ? history.fechaHistory : new Date(),
            }
            yield firebaseDatabase.collection(process.env.REACT_APP_FIREBASE_COLECCION_COMPANY)
                .doc(numDocBD).set({ state: estados.VALIDACION_RYA, validRya: validRy, date: validRy.fechaFin }, { merge: true });
        }
    } catch (error) {
        console.error('saga.searchFormFromTable', error)
        yield put(errorGeneral(manejoDeexepciones(error)));
    }
}

function* cosumeConsultaBigquery(action) {
    try {
        const { body } = action;
        const headers = HEADERS_WS;
        const respues = yield call(axios.post, process.env.REACT_APP_URL_CONSULTAS_BIGQUERY, body, headers);
        // const respues = yield call(axios.post, "http://127.0.0.1:5001/afiliacionempresasprueba-f1bbf/us-central1/consultasbigquery", body, headers);
        return respues.data;
    } catch (error) {
        console.error("Function.cosumeConsultaBigquery", error);
        throw error;
    }

}

function* consumeServiceGenerico(action) {
    try {
        const { body, url } = action;


        const request = { urlServicio: url, body: body }
        const headers = HEADERS_WS;
        const respues = yield call(axios.post, process.env.REACT_APP_FIREBASE_SEND_CONSUME_SERVICIOS_GENERICOS, request, headers);
        return respues.data;
    } catch (error) {
        console.error("Function.consumeServiceGenerico", error);
        throw error;
    }

}

function* consumeActualizaOportunidad(action) {
    /*Función que actualiza la oportunidad
     *Recibe, el tipo de identificacion y el numero, la fase de venta, y una nota si la hay
     *Si el formulario genero algun error se envia un json diferente 
     */
    const { faseVenta, anexos, itemsForm, nota, idMotivo, estado } = action;
    const id = itemsForm.stepPrincipal.afiliacionEmpresas.numberIdCompanyGes;
    const tipo = itemsForm.stepPrincipal.afiliacionEmpresas.typeIdCompanyGes;
    const idOportunidad = itemsForm.idOportunidad;

    const messageid = tipo + id;

    var date = "";
    var date = new Date();
    var archivo = [];

    var infoOportu = {
        "idOportunidad": idOportunidad,
        "faseVenta": faseVenta,
        "archivo": archivo,
        "idMotivo": idMotivo ? idMotivo : "",
        "estado": estado ? estado : null,
        "nota": nota //tipo id nombre correo celular cargo \n tipo id nombre correo celular cargo
    }

    const urlConfenalco = process.env.REACT_APP_COMFENALCO_URL_CREATE_UPDATE_OPORTUNIDAD;

    const body = {
        "requestMessageOut": {
            "header": {
                "invokerDateTime": date,
                "moduleId": "OPORTUNIDAD",
                "systemId": "FORMULARIOSWEB",
                "messageId": messageid,
                "logginData": {
                    "sourceSystemId": "",
                    "destinationSystemId": ""
                },
                "destination": {
                    "namespace": "http://co/com/comfenalcovalle/esb/ws/CRMCreaActualizaOportunidad",
                    "name": "CRMCreaActualizaOportunidad",
                    "operation": "execute"
                },
                "securityCredential": {
                    "userName": "",
                    "userToken": ""
                },
                "classification": {
                    "classification": ""
                }
            },
            "body": {
                "request": {
                    "oportunidad": {
                        "accion": "2",
                        "infoOportunidad": infoOportu,
                    }
                }
            }
        }
    }
    var resul = false;
    try {
        console.time("inicio");
        console.log("body oportunidad", JSON.stringify(body))
        const res = yield consumeServiceGenerico({ body, url: urlConfenalco });
        console.log("response oportunidad", res)

        const idForm = yield select(getIdFormulario);
        let status = "FAILURE";
        if (res.responseMessageOut.header.responseStatus.statusCode === "SUCESS" && res.responseMessageOut.body.response.mensaje === "ok") {
            //TODO: capturar el mensaje de exito
            //Oportunidad actualizada con exito
            resul = true;
            status = "SUCESS";
        } else {
            //TODO: capturar la falla y el proceso a seguir
            notificaFalloWBS({ body, webService: "Actualiza la oportunidad", response: res.responseMessageOut.body })
        }
        saveBdWebService(idForm, "CRMCreaActualizaOportunidad", { ...body }, status, res.responseMessageOut.body);

        console.timeEnd("inicio");
        return resul;
    } catch (error) {
        console.error("actualizaOportunidad - exception:", error);
        throw error;
    }

}

function* consumeActualizaTicket(action) {
    /*Función que actualiza la oportunidad
     *Recibe, el tipo de identificacion y el numero, la fase de venta, y una nota si la hay
     *Si el formulario genero algun error se envia un json diferente 
     */
    const { estadoTicket, itemsForm, nota, idFormulario } = action;
    const id = itemsForm.stepPrincipal.afiliacionEmpresas.numberIdCompanyGes;
    const tipo = itemsForm.stepPrincipal.afiliacionEmpresas.typeIdCompanyGes;
    const idTicket = itemsForm.ticketAfiliacion;
    const messageid = tipo + id;

    var date = "";
    var date = new Date();

    const urlConfenalco = process.env.REACT_APP_COMFENALCO_URL_CREATE_UPDATE_OPORTUNIDAD;

    const body = {
        "requestMessageOut": {
            "header": {
                "invokerDateTime": date,
                "moduleId": "FORMULARIOS",
                "systemId": "PORTAL",
                "messageId": messageid,
                "logginData": {
                    "sourceSystemId": null,
                    "destinationSystemId": null
                },
                "destination": {
                    "namespace": "http://co/com/comfenalcovalle/esb/ws/InQueueCRMCreaTicketContactenos",
                    "name": "CRMCreaTicketContactenos",
                    "operation": "execute"
                },
                "classification": {
                    "classification": null
                }
            },
            "body": {
                "request": {
                    "accion": "2",
                    "idTicket": idTicket,
                    "tipoCliente": "E",
                    "estadoTicket": estadoTicket,
                    "text": nota
                }
            }
        }
    }
    var resul = false;
    try {
        console.time("inicio");
        console.log("body ticket", JSON.stringify(body))
        const res = yield consumeServiceGenerico({ body, url: urlConfenalco });
        console.log("response ticket", res)
        let status = "FAILURE";
        if (res.responseMessageOut.header.responseStatus.statusCode === "SUCESS") {
            //TODO: capturar el mensaje de exito
            //ticket actualizada con exito
            resul = true;
            status = "SUCESS"
        } else {
            //TODO: capturar la falla y el proceso a seguir
            notificaFalloWBS({ body, webService: "Actualiza el ticket", response: res.responseMessageOut.body });
        }
        saveBdWebService(idFormulario, "CRMCreaTicketContactenos", { ...body }, status, res.responseMessageOut.body);

        console.timeEnd("inicio");
        return resul;
    } catch (error) {
        console.error("consumeActualizaTicket - exception:", error);
        throw error;
    }

}

function* getUserRols(action) {
    try {
        const data = yield getAsyncCatalogV2('USERS_ROLS_SUCURSALES');
        yield put(validateUserTypeSuccess({ valid: false, data }))
    } catch (error) {
        yield put(errorGeneral(manejoDeexepciones(error)));
    }

}


function* initValidateUser(action) {
    /*
  función que recibe los datos de la sesion de colaboradores
  crea el usuario y envia a buscar las solicitudes correspondientes por id_sucursal y/o por rol
  */
    try {
        const { value: { type, user } } = action;
        
        let userInfo = {}

        if (type === "auth0")
            userInfo = {
                email: emptyObject(user["email"]),
                emailVerified: emptyObject(user["email_verified"]),
                names: emptyObject(user["family_name"]),
                lasNames: emptyObject(user["given_name"]),
                idUser: emptyObject(user["https://test-empresas-comf.com/employ/id_usua"]),
                cellPhone: emptyObject(user["https://test-empresas-comf.com/employ/rest_celular"]),
                id: emptyObject(user["https://test-empresas-comf.com/employ/rest_id"]),
                tipoUser: emptyObject(user["https://test-empresas-comf.com/employ/tipo"]),
                tipoId: emptyObject(user["https://test-empresas-comf.com/employ/tipo_identificacion"]),
                nameCompleted: emptyObject(user["name"]),
                nickname: emptyObject(user["nickname"]),
                rol: "comercial",
                actionAnular: false
            }
        else {
            const resUser = yield searchUser();
            
            if (resUser) {
                userInfo = {
                    email: emptyObject(resUser["comfenApp/colab/email"]),
                    emailVerified: true,
                    names: emptyObject(resUser["comfenApp/colab/rest_name"]),
                    lasNames: emptyObject(resUser["comfenApp/colab/rest_lname"]),
                    idUser: emptyObject(resUser["comfenApp/colab/id_usua"]),
                    cellPhone: emptyObject(resUser["comfenApp/colab/rest_celular"]),
                    id: emptyObject(resUser["comfenApp/colab/idPers"]),
                    tipoUser: emptyObject(resUser["comfenApp/colab/tipo"]),
                    tipoId: emptyObject(resUser["comfenApp/colab/tipo_identificacion"]),
                    nameCompleted: `${emptyObject(resUser["comfenApp/colab/rest_name"])} ${emptyObject(resUser["comfenApp/colab/rest_lname"])}`,
                    nickname: emptyObject(resUser["nickname"]),
                    rol: "comercial"
                }
            }
        }
        // let userInfo = {
        //     email: "pafr0929@gmail.com",
        //     emailVerified: true,
        //     names: "freire",
        //     lasNames: "pablo",
        //     idUser: "203431",
        //     cellPhone: "",
        //     id: "1109661476",
        //     tipoUser: "C",
        //     tipoId: "CC",
        //     nameCompleted: "pablo freire",
        //     nickname: "pabfre9",
        //     rol: "comercial"
        // }

        if (userInfo.email) {
            const user = yield getAsyncUserRolFirebase(userInfo.email);
            if (user) {
                userInfo.actionAnular = user.actionAnular ? user.actionAnular : false;
                let suc_id = false;
                suc_id = user.suc_id.toString();
                yield put(typeUserBandeja({ rol: user.rol, suc_id, idUsuaAsesor: userInfo.idUser, emailAsesor: userInfo.email }));
                userInfo.rol = user.rol === "comercial" ? "Asesor comercial" : user.rol === "rya" ? "Asesor RyA" : "Ejecutivo corporativo";
                yield put(savedInfoUserBandeja(userInfo));
                if (suc_id) {
                    yield obtenerDatosRegCompany({ suc_id })
                }
            } else {
                //usuario sin permisos
                const msgParametrizados = yield select(getMsgParametrizados);
                yield put(messageAlertSend(
                    {
                        message: yield generateMsgParametrizado(msgParametrizados, "msgNotPermitAccessUser"),
                        error: true,
                    }))
            }
        }

    } catch (error) {
        console.error('saga.initValidateUser', error)
        yield put(errorGeneral(manejoDeexepciones(error)));
    }
}

function* onreduxBlur(action) {
    const { meta: { field, form }, payload, } = action;
    try {

        const fields = field.split('.');
        let data = "";
        let dynamicOptions = false;
        switch (fields[1]) {
            case "dateStart":
                data = yield select(getFormValuesFilter);
                if (!(data && data.informesCompanys))
                    data = { informesCompanys: {} }

                if (!data.informesCompanys.dateEnd) {
                    data.informesCompanys.dateEnd = new Date();
                    yield put(initialize(REPORTS_FORM_NAME, data));
                }

                yield put(callDinamicDisableLote([
                    { field: "idCompanyReport", state: true },
                    { field: "idOportunidadReport", state: true },
                ]));

                return;

            case "idCompanyReport":
                data = yield select(getFormValuesFilter);
                if (!(data && data.informesCompanys))
                    data = { informesCompanys: {} }
                data.informesCompanys.dateStart = ""
                data.informesCompanys.dateEnd = ""
                data.informesCompanys.idOportunidadReport = ""
                data.informesCompanys.stateAfilia = ""
                data.informesCompanys.idDocuReport = ""

                return yield put(initialize(REPORTS_FORM_NAME, data));

            case "idOportunidadReport":
                data = yield select(getFormValuesFilter);
                if (!(data && data.informesCompanys))
                    data = { informesCompanys: {} }
                data.informesCompanys.dateStart = ""
                data.informesCompanys.dateEnd = ""
                data.informesCompanys.idCompanyReport = ""
                data.informesCompanys.stateAfilia = ""
                data.informesCompanys.idDocuReport = ""

                return yield put(initialize(REPORTS_FORM_NAME, data));

            case "idDocuReport":
                data = yield select(getFormValuesFilter);
                if (!(data && data.informesCompanys))
                    data = { informesCompanys: {} }
                data.informesCompanys.dateStart = ""
                data.informesCompanys.dateEnd = ""
                data.informesCompanys.idCompanyReport = ""
                data.informesCompanys.stateAfilia = ""
                data.informesCompanys.idOportunidadReport = ""

                return yield put(initialize(REPORTS_FORM_NAME, data));

            case "stateAfilia":
                data = yield select(getFormValuesFilter);
                if (!(data && data.informesCompanys))
                    data = { informesCompanys: {} }
                data.informesCompanys.idCompanyReport = ""
                data.informesCompanys.idOportunidadReport = ""
                data.informesCompanys.idDocuReport = ""
                data.informesCompanys.stateAfilia = data.informesCompanys.stateAfilia === "clean" ? "" : data.informesCompanys.stateAfilia

                return yield put(initialize(REPORTS_FORM_NAME, data));

            case "motivoDevolucion":
                dynamicOptions = yield select(getDynamicOptions);
                if (!existLabel(dynamicOptions["motivoDevolucion"], payload))
                    yield put(change(DEVOLUCIONES_FORM_NAME, field, ""))
                return;

            case "motivoAnulacion":
                dynamicOptions = yield select(getDynamicOptions);
                if (!existLabel(dynamicOptions["motivoAnulacion"], payload))
                    yield put(change(ANULACION_FORM_NAME, field, ""))
                return;

            case "motivoAnulacionForm":
                dynamicOptions = yield select(getDynamicOptions);
                if (!existLabel(dynamicOptions["motivoAnulacionForm"], payload))
                    yield put(change(ANULACION_FORM_NAME_V2, field, ""))
                return;

            case "societyType":
                dynamicOptions = yield select(getDynamicOptions);
                if (!existLabel(dynamicOptions["societyType"], payload))
                    yield put(change(REGISTRO_AND_APORTES_FORM_NAME, field, ""))
                return;

            default:
                return;
        }

    } catch (error) {
        console.error("Saga.reduxblur", error);
        yield put(errorGeneral(manejoDeexepciones(error)));
    }
}

function* onReduxChange(action) {
    const { meta: { field, form }, payload, } = action;
    try {
        let data = {};
        switch (field) {
            case "datosanulacion.motivoAnulacion":
                yield put(initialize(DEVOLUCIONES_FORM_NAME, {}));
                return yield put(ocultarDevoluciones(true));

            case "datosanulacion.observationAnulation":
                yield put(initialize(DEVOLUCIONES_FORM_NAME, {}));
                return yield put(ocultarDevoluciones(true));;

            case "datosdevolucion.motivoDevolucion":
                return yield put(initialize(ANULACION_FORM_NAME, {}));

            case "datosdevolucion.observation":
                return yield put(initialize(ANULACION_FORM_NAME, {}));

            case "informesCompanys.dateStart":
                data = yield select(getFormValuesFilter);
                if (!(data && data.informesCompanys))
                    data = { informesCompanys: {} }

                if (!data.informesCompanys.dateEnd) {
                    data.informesCompanys.dateEnd = new Date();
                }

                data.informesCompanys.idCompanyReport = ""
                data.informesCompanys.idOportunidadReport = ""
                data.informesCompanys.idDocuReport = ""
                data.informesCompanys.stateAfilia = data.informesCompanys.stateAfilia === "clean" ? "" : data.informesCompanys.stateAfilia

                return yield put(initialize(REPORTS_FORM_NAME, data));

            case "informesCompanys.idCompanyReport":
                data = yield select(getFormValuesFilter);
                if (!(data && data.informesCompanys))
                    data = { informesCompanys: {} }
                data.informesCompanys.dateStart = ""
                data.informesCompanys.dateEnd = ""
                data.informesCompanys.idOportunidadReport = ""
                data.informesCompanys.stateAfilia = Array.isArray(data.informesCompanys.stateAfilia) ? "clean" : ""
                data.informesCompanys.idDocuReport = ""

                return yield put(initialize(REPORTS_FORM_NAME, data));

            case "informesCompanys.idOportunidadReport":
                data = yield select(getFormValuesFilter);
                if (!(data && data.informesCompanys))
                    data = { informesCompanys: {} }
                data.informesCompanys.dateStart = ""
                data.informesCompanys.dateEnd = ""
                data.informesCompanys.idCompanyReport = ""
                data.informesCompanys.stateAfilia = Array.isArray(data.informesCompanys.stateAfilia) ? "clean" : ""
                data.informesCompanys.idDocuReport = ""

                return yield put(initialize(REPORTS_FORM_NAME, data));

            case "informesCompanys.idDocuReport":
                data = yield select(getFormValuesFilter);
                if (!(data && data.informesCompanys))
                    data = { informesCompanys: {} }
                data.informesCompanys.dateStart = ""
                data.informesCompanys.dateEnd = ""
                data.informesCompanys.idCompanyReport = ""
                data.informesCompanys.stateAfilia = Array.isArray(data.informesCompanys.stateAfilia) ? "clean" : ""
                data.informesCompanys.idOportunidadReport = ""

                return yield put(initialize(REPORTS_FORM_NAME, data));

            case "informesCompanys.stateAfilia":
                data = yield select(getFormValuesFilter);
                if (!(data && data.informesCompanys))
                    data = { informesCompanys: {} }

                data.informesCompanys.idCompanyReport = ""
                data.informesCompanys.idOportunidadReport = ""
                data.informesCompanys.idDocuReport = ""
                data.informesCompanys.stateAfilia = data.informesCompanys.stateAfilia === "clean" ? "" : data.informesCompanys.stateAfilia

                return yield put(initialize(REPORTS_FORM_NAME, data));

            case "informesCompanys.dateEnd":
                data = yield select(getFormValuesFilter);
                if (!(data && data.informesCompanys))
                    data = { informesCompanys: {} }

                data.informesCompanys.idCompanyReport = ""
                data.informesCompanys.idOportunidadReport = ""
                data.informesCompanys.idDocuReport = ""
                data.informesCompanys.stateAfilia = data.informesCompanys.stateAfilia === "clean" ? "" : data.informesCompanys.stateAfilia

                return yield put(initialize(REPORTS_FORM_NAME, data));

            default:
                return;
        }



    } catch (error) {
        console.error("Saga.onReduxChange", error);
        yield put(errorGeneral(manejoDeexepciones(error)));
    }
}

function validateDevolverForm(action) {
    try {
        return (!action || !action.datosdevolucion["motivoDevolucion"] || !action.datosdevolucion["observation"]) ? false : true;
    } catch (error) {
        console.error("Saga.validateDevolverForm", error);
        throw error;
    }
}

function validateRyaForm(action) {
    try {
        return (!action || !action.datosrya["societyType"]) ? false : true;
    } catch (error) {
        console.error("Saga.validateRyaForm", error);
        throw error;
    }
}

function validateAnularForm(action) {
    try {
        return (!action || !action.datosanulacion["motivoAnulacion"] || !action.datosanulacion["observationAnulation"]) ? false : true;
    } catch (error) {
        console.error("Saga.validateAnularForm", error);
        throw error;
    }
}

function validateAnularV2Form(action) {
    try {
        return (!action || !action.datosanulacionform["motivoAnulacionForm"] || !action.datosanulacionform["motivoAnulacionForm"]) ? false : true;
    } catch (error) {
        console.error("Saga.validateAnularV2Form", error);
        throw error;
    }
}

function* actionsCompanyRya(action) {
    /*
función que recibe las dos acciones posibles para el asesor de registro y aportes 
afiliar y devolver a comercial y realiza su logica respecto a a accion solicitada
*/
    try {
        yield put(openModalCharged(true));
        yield put(sendMessageConfirmationRya(false))
        const { value: { messageConfirmation: { actionValid, data }, anexos, itemsForm, catalog } } = action;
        console.log(action)

        const idFormulario = yield select(getIdFormulario);
        const userInfo = yield select(getUserInfo);
        const actionsForm = actionValid.toUpperCase();
        if (actionsForm === "DEVOLVER_COMERCIAL") {
            let resultadoValidacion = {
                fechaValidacion: new Date(),
                accionRealizada: "Devolver comercial",
                motivo: data.datosdevolucion?.motivoDevolucion,
                observacion: emptyObject(data.datosdevolucion?.observation)
            }

            const history = {
                fechaHistory: new Date(),
                tomado: userInfo.rol,
                infoUsuario: userInfo,
                resultadoValidacion,
            }

            const devolucionComercial = {
                fecha: history.fechaHistory,
                motivo: resultadoValidacion.motivo,
                observacion: emptyObject(resultadoValidacion.observacion),
                user: userInfo
            }
            const catalog = yield select(getDynamicOptions)
            const idMotivo = yield retornaIdCatalog(catalog.motivoDevolucion, resultadoValidacion.motivo);
            const nota = `Información devolución rya\n\nObservacion: ${emptyObject(resultadoValidacion.observacion)} \nMotivo: ${emptyObject(resultadoValidacion.motivo)}`;
            //Al devolver a comercial se invoca el servicio de actualizar oportunidad y se realiza el proceso
            const resultDevolverComercial = yield consumeActualizaOportunidad({ faseVenta: "Z95", anexos: false, idMotivo, itemsForm, nota, idFormulario: false, estado: "2" });
            if (resultDevolverComercial) {
                yield firebaseDatabase.collection(process.env.REACT_APP_FIREBASE_COLECCION_COMPANY)
                    .doc(idFormulario).set({ state: estados.DEVUELTA_COMERCIAL, devolucionComercial, date: devolucionComercial.fecha }, { merge: true });

                saveHistoryEmpresas({ history, idFormulario });

                const msgParametrizados = yield select(getMsgParametrizados);
                yield put(messageAlertSend(
                    {
                        message: yield generateMsgParametrizado(msgParametrizados, "msgDevolCmrSuccess"),
                        error: false,
                        home: true
                    }))

                const suc_id = yield select(getSuc_id);
                yield obtenerDatosRegCompany({ suc_id });

            } else {
                yield put(openModalCharged(false));
                //let complemento = response.data.mensajeRespuesta.error.split("line 103");
                const msgParametrizados = yield select(getMsgParametrizados);
                yield put(messageAlertSend(
                    {
                        message: yield generateMsgParametrizado(msgParametrizados, "msgDevolCmrFailure"),
                        error: true,
                    }))


                let resultadoValidacion = {
                    fechaValidacion: new Date(),
                    accionRealizada: "Actualizar oportunidad en devolución a comercial",
                    observacion: `No realizado, el servicio de actualizar no respondio`
                }
                let tomado = "Asesor RyA";
                const history = {
                    fechaHistory: new Date(),
                    tomado,
                    infoUsuario: userInfo,
                    resultadoValidacion,
                }

                saveHistoryEmpresas({ history, idFormulario })
            }
            //Todo enviar correo al usuario
            yield put(openModalCharged(false));
        } else if (actionsForm === "AFILIAR") {

            const dataAfiliar = yield select(getFormValuesRyaForm);
            let body = yield createBodyAfiliaCompany({ items: itemsForm, anexos, catalog, dataAfiliar, idFormulario });
            console.log(JSON.stringify(body), "afiliacion send")
            const response = yield sendGrabaAfiliacion({ idFormulario, bodyRequest: body });

            console.log(response, "afiliacion return")
            if (response && response.status === 200) {
                if (response.data && response.data.mensajeRespuesta?.mensaje) {


                    let resultadoValidacion = {
                        fechaValidacion: new Date(),
                        accionRealizada: "Afiliar",
                        observacion: "Afiliacion realizada exitosamente"
                    }
                    let tomado = "Asesor RyA";
                    const history = {
                        fechaHistory: new Date(),
                        tomado,
                        infoUsuario: userInfo,
                        resultadoValidacion,
                    }

                    // const afiliacion = {
                    //     fecha: history.fechaHistory,
                    //     observacion: resultadoValidacion.observacion,
                    //     user: userInfo
                    // }
                    // yield firebaseDatabase.collection(process.env.REACT_APP_FIREBASE_COLECCION_COMPANY)
                    //     .doc(idFormulario).set({ state: estados.AFILIADA, afiliacion, date: afiliacion.fecha }, { merge: true });

                    // saveHistoryEmpresas({ history, idFormulario });

                    const resulTicket = yield consumeActualizaTicket({ estadoTicket: "5", itemsForm, nota: "Cerrado por afiliación", idFormulario });
                    if (resulTicket) {

                        const afiliacion = {
                            fecha: history.fechaHistory,
                            observacion: resultadoValidacion.observacion,
                            user: userInfo
                        }
                        yield firebaseDatabase.collection(process.env.REACT_APP_FIREBASE_COLECCION_COMPANY)
                            .doc(idFormulario).set({ state: estados.AFILIADA, afiliacion, date: afiliacion.fecha }, { merge: true });

                        //TODO consume servicio actualiza la oportunidad
                        const resultAfiliar = yield consumeActualizaOportunidad({ faseVenta: "Z28", anexos: false, itemsForm, nota: "Afiliación terminada satisfactoriamente.", idFormulario: false, estado: "4" });

                        if (resultAfiliar) {


                            saveHistoryEmpresas({ history, idFormulario });

                            const msgParametrizados = yield select(getMsgParametrizados);
                            yield put(messageAlertSend(
                                {
                                    message: `${yield generateMsgParametrizado(msgParametrizados, "msgAfiliaSuccess")} ${response.data.mensajeRespuesta.idDocu}.`,
                                    error: false,
                                    home: true
                                }));


                            const suc_id = yield select(getSuc_id);
                            yield obtenerDatosRegCompany({ suc_id });
                        } else {
                            yield put(openModalCharged(false));
                            //let complemento = response.data.mensajeRespuesta.error.split("line 103");
                            const msgParametrizados = yield select(getMsgParametrizados);
                            yield put(messageAlertSend(
                                {
                                    message: yield generateMsgParametrizado(msgParametrizados, "msgAfiliaFailure"),
                                    error: true,
                                }))


                            let resultadoValidacion = {
                                fechaValidacion: new Date(),
                                accionRealizada: "Actualizar ticket en afiliación",
                                observacion: `No realizado, sin respuesta`
                            }
                            let tomado = "Asesor RyA";
                            const history = {
                                fechaHistory: new Date(),
                                tomado,
                                infoUsuario: userInfo,
                                resultadoValidacion,
                            }

                            saveHistoryEmpresas({ history, idFormulario })
                        }
                    } else {
                        yield put(openModalCharged(false));
                        //let complemento = response.data.mensajeRespuesta.error.split("line 103");
                        const msgParametrizados = yield select(getMsgParametrizados);
                        yield put(messageAlertSend(
                            {
                                message: yield generateMsgParametrizado(msgParametrizados, "msgAfiliaFailure"),
                                error: true,
                            }))


                        let resultadoValidacion = {
                            fechaValidacion: new Date(),
                            accionRealizada: "Actualizar oportunidad en afiliación",
                            observacion: `No realizado, el servicio de actualizar no respondio`
                        }
                        let tomado = "Asesor RyA";
                        const history = {
                            fechaHistory: new Date(),
                            tomado,
                            infoUsuario: userInfo,
                            resultadoValidacion,
                        }

                        saveHistoryEmpresas({ history, idFormulario })
                    }

                }
                else {
                    yield put(openModalCharged(false));
                    //let complemento = response.data.mensajeRespuesta.error.split("line 103");
                    yield put(messageAlertSend(
                        {
                            message: `No se pudo realizar el proceso de afiliación correctamente, la respuesta al proceso es: ${emptyObject(response.data?.mensajeRespuesta?.error)} .Si el problema persiste comuniquese con el area de soporte ComfenalcoValle delagente`,
                            error: true,
                        }))


                    let resultadoValidacion = {
                        fechaValidacion: new Date(),
                        accionRealizada: "Afiliar",
                        observacion: `No realizado ${emptyObject(response.data?.mensajeRespuesta?.error)}`
                    }
                    let tomado = "Asesor RyA";
                    const history = {
                        fechaHistory: new Date(),
                        tomado,
                        infoUsuario: userInfo,
                        resultadoValidacion,
                    }

                    saveHistoryEmpresas({ history, idFormulario })
                }
                //yield put(returnHomeBandeja(true));
                yield put(openModalCharged(false));
            } else {
                yield put(openModalCharged(false));
                const msgParametrizados = yield select(getMsgParametrizados);
                yield put(messageAlertSend(
                    {
                        message: yield generateMsgParametrizado(msgParametrizados, "msgAfiliaFailure"),
                        error: true,
                    }))

                let resultadoValidacion = {
                    fechaValidacion: new Date(),
                    accionRealizada: "Afiliar",
                    observacion: `Web service fuera de linea. No realizado`
                }
                let tomado = "Asesor RyA";
                const history = {
                    fechaHistory: new Date(),
                    tomado,
                    infoUsuario: userInfo,
                    resultadoValidacion,
                }

                saveHistoryEmpresas({ history, idFormulario })
            }

        }
        yield put(openModalCharged(false));

    } catch (error) {
        console.error("Saga.actionsCompanyRya", error);
        yield put(errorGeneral(manejoDeexepciones(error)));
    }
}

function* onActionsAprove(action) {
    try {
        const { value } = action;
        switch (value.toUpperCase()) {
            case "DEVOLVER":
                const dataDevolver = yield select(getFormValuesDevolucion);

                if (validateDevolverForm(dataDevolver))

                    yield put(messageConfirmationSend({
                        message: `¿Está seguro de realizar la devolución? Motivo: ${dataDevolver.datosdevolucion.motivoDevolucion}`,
                        actionValid: value,
                        data: dataDevolver,
                    }));
                else
                    yield put(messageAlertSend(
                        {
                            message: "Debe diligenciar los datos de la devolución antes de continuar",
                            error: true,
                        }));
                return;

            case "ANULAR":
                const dataAnular = yield select(getFormValuesAnulacion);

                if (validateAnularForm(dataAnular))
                    yield put(messageConfirmationSend({
                        message: `Esta seguro de continuar con la anulación con motivo: ${dataAnular.datosanulacion.motivoAnulacion}`,
                        actionValid: value,
                        data: dataAnular
                    }));
                else
                    yield put(messageAlertSend(
                        {
                            message: "Debe diligenciar los datos de la anulación antes de continuar",
                            error: true,
                        }));
                return;

            case "APROBAR":
                yield put(messageConfirmationSend({
                    message: "Esta seguro de continuar con la aprobación de esta inscripción",
                    actionValid: value,
                    data: false,
                }));
                return;

            case "APROBAR_EJECUTIVO":
                yield put(messageConfirmationSend({
                    message: "Esta seguro de continuar con la aprobación de esta inscripción para validación comercial",
                    actionValid: value,
                    data: false,
                }));
                return;

            default:
                return;
        }

    } catch (error) {
        console.error("Saga.onActionsAprove", error);
        yield put(errorGeneral(manejoDeexepciones(error)));
    }
}

function* onActionsAproveRya(action) {
    //Cuando el asesor rya escoge afiliar o devolver, se presenta el mensaje de si esta seguro de hacerlo
    try {

        const { value: { act, empleadorType } } = action;
        switch (act.toUpperCase()) {
            case "AFILIAR":
                const dataAfiliar = yield select(getFormValuesRyaForm);
                if (empleadorType === "1") {
                    if (dataAfiliar && validateRyaForm(dataAfiliar))
                        yield put(sendMessageConfirmationRya({
                            message: "Esta seguro de continuar con la afiliación de esta inscripción",
                            actionValid: act,
                            data: false,

                        }));

                    else
                        yield put(messageAlertSend(
                            {
                                message: "Debe diligenciar los datos de tipos de sociedad antes de continuar",
                                error: true,
                            }));
                } else {
                    yield put(sendMessageConfirmationRya({
                        message: "Esta seguro de continuar con la afiliación de esta inscripción",
                        actionValid: act,
                        data: false,

                    }));
                }
                return;

            case "DEVOLVER_COMERCIAL":
                const dataDevolverComer = yield select(getFormValuesDevolucion);
                if (validateDevolverForm(dataDevolverComer))
                    yield put(sendMessageConfirmationRya({
                        message: `Esta seguro de continuar con la devolución, con motivo: ${dataDevolverComer.datosdevolucion.motivoDevolucion}`,
                        actionValid: act,
                        data: dataDevolverComer,
                    }));
                else
                    yield put(messageAlertSend(
                        {
                            message: "Debe diligenciar los datos de la devolución antes de continuar",
                            error: true,
                        }));
                return;
            default:
                return;
        }

    } catch (error) {
        console.error("Saga.onActionsAproveRya", error);
        yield put(errorGeneral(manejoDeexepciones(error)));
    }
}

function* savedActionsHistory(action) {
    /*
función que recibe las dos acciones posibles para el asesor comercial 
devolver, anular y aprobar y realiza su logica respecto a a accion solicitada
*/
    try {
        const { value: { messageConfirmation: { data, actionValid }, anexos, itemsForm } } = action;

        yield put(closeModales());
        yield put(openModalCharged(true));
        const idFormulario = yield select(getIdFormulario);
        const userInfo = yield select(getUserInfo);
        const actionsForm = actionValid.toUpperCase();
        let history = {
        }
        let resultadoValidacion = {
            fechaValidacion: new Date(),
            accionRealizada: actionsForm,
        }

        let tomado = "Asesor comercial";
        let stateReg = estados.FIRMADA;

        //bandera que define si se actualiza el estado de la afiliación
        let procesoExitoso = false;

        if (actionsForm === "DEVOLVER") {
            resultadoValidacion.motivo = data.datosdevolucion?.motivoDevolucion;
            resultadoValidacion.observacion = emptyObject(data.datosdevolucion?.observation);
            stateReg = estados.DEVUELTA;
            const email = itemsForm.step0.datosinicio.emailCompanyStart;
            //TODO consume servicio actualiza la oportunidad
            const catalog = yield select(getDynamicOptions)
            const idMotivo = yield retornaIdCatalog(catalog.motivoDevolucion, resultadoValidacion.motivo);
            const nota = `Información devolución comercial\n\nObservacion: ${emptyObject(resultadoValidacion.observacion)} \nMotivo: ${emptyObject(resultadoValidacion.motivo)}`;
            const resultDevolver = yield consumeActualizaOportunidad({ faseVenta: "Z66", idMotivo, anexos: false, itemsForm, nota, idFormulario: false, estado: "2" });
            if (resultDevolver) {
                const resulTicket = yield consumeActualizaTicket({ estadoTicket: "Z8", itemsForm, nota: "Cerrado por devolución", idFormulario });
                if (resulTicket) {
                    procesoExitoso = true;
                    //enviarEmailFormatDocument({ from: "Notificaciones bandeja comercial", to: email, subject: "Notificación de devolución de empresa por parte de validación comercial", type: "DEVOLUCION", motivo: resultadoValidacion.motivo, observacion: resultadoValidacion.observacion, numRegistro: itemsForm.idOportunidad });
                    const msgParametrizados = yield select(getMsgParametrizados);
                    yield put(messageAlertSend(
                        {
                            message: yield generateMsgParametrizado(msgParametrizados, "msgDevolSuccess"),
                            error: false,
                            home: true
                        }))

                    const suc_id = yield select(getSuc_id);
                    yield obtenerDatosRegCompany({ suc_id });
                } else {
                    yield put(openModalCharged(false));

                    const msgParametrizados = yield select(getMsgParametrizados);
                    yield put(messageAlertSend(
                        {
                            message: yield generateMsgParametrizado(msgParametrizados, "msgDevolFailure"),
                            error: true,
                        }))


                    resultadoValidacion = {
                        fechaValidacion: new Date(),
                        accionRealizada: "Actualizar ticket en devolucion",
                        observacion: `No realizado, sin respuesta`
                    }
                    let tomado = "Asesor Comercial";
                    history = {
                        fechaHistory: new Date(),
                        tomado,
                        infoUsuario: userInfo,
                        resultadoValidacion,
                    }

                    saveHistoryEmpresas({ history, idFormulario })
                }
            } else {
                yield put(openModalCharged(false));

                const msgParametrizados = yield select(getMsgParametrizados);
                yield put(messageAlertSend(
                    {
                        message: yield generateMsgParametrizado(msgParametrizados, "msgDevolFailure"),
                        error: true,
                    }))


                resultadoValidacion = {
                    fechaValidacion: new Date(),
                    accionRealizada: "Actualizar oportunidad en devolución",
                    observacion: `No realizado, el servicio de actualizar no respondio`
                }
                let tomado = "Asesor Comercial";
                history = {
                    fechaHistory: new Date(),
                    tomado,
                    infoUsuario: userInfo,
                    resultadoValidacion,
                }

                saveHistoryEmpresas({ history, idFormulario })
            }


        } else if (actionsForm.includes("ANULAR")) {
            resultadoValidacion.motivo = data.datosanulacion?.motivoAnulacion;
            resultadoValidacion.observacion = emptyObject(data.datosanulacion?.observationAnulation);
            stateReg = estados.ANULADA;

            const catalog = yield select(getDynamicOptions)
            const idMotivo = yield retornaIdCatalog(catalog.motivoAnulacion, resultadoValidacion.motivo);
            const nota = `Información anulación o rechazo\n\nObservacion: ${emptyObject(resultadoValidacion.observacion)} \nMotivo: ${emptyObject(resultadoValidacion.motivo)}`;
            const resultAnular = yield consumeActualizaOportunidad({ faseVenta: "Z94", idMotivo, anexos: false, itemsForm, nota, idFormulario: false, estado: "5" });
            if (resultAnular) {

                const resulTicket = yield consumeActualizaTicket({ estadoTicket: "Z7", itemsForm, nota: "Cerrado por anulación", idFormulario });
                if (resulTicket) {
                    procesoExitoso = true;
                    const email = itemsForm.step0.datosinicio.emailCompanyStart;
                    //enviarEmailFormatDocument({ from: "Notificaciones bandeja comercial", to: email, subject: "Notificación de anulación de empresa por parte de validación comercial", type: "ANULACION", motivo: resultadoValidacion.motivo, observacion: resultadoValidacion.observacion })

                    const msgParametrizados = yield select(getMsgParametrizados);
                    yield put(messageAlertSend(
                        {
                            message: yield generateMsgParametrizado(msgParametrizados, "msgAnulaSuccess"),
                            error: false,
                            home: true
                        }))

                    const suc_id = yield select(getSuc_id);
                    yield obtenerDatosRegCompany({ suc_id });
                } else {
                    yield put(openModalCharged(false));

                    const msgParametrizados = yield select(getMsgParametrizados);
                    yield put(messageAlertSend(
                        {
                            message: yield generateMsgParametrizado(msgParametrizados, "msgAnulaFailure"),
                            error: true,
                        }))


                    resultadoValidacion = {
                        fechaValidacion: new Date(),
                        accionRealizada: "Actualizar ticket en anulación",
                        observacion: `No realizado, sin respuesta`
                    }
                    let tomado = "Asesor Comercial";
                    history = {
                        fechaHistory: new Date(),
                        tomado,
                        infoUsuario: userInfo,
                        resultadoValidacion,
                    }

                    saveHistoryEmpresas({ history, idFormulario })
                }
            } else {
                yield put(openModalCharged(false));
                const msgParametrizados = yield select(getMsgParametrizados);
                yield put(messageAlertSend(
                    {
                        message: yield generateMsgParametrizado(msgParametrizados, "msgAnulaFailure"),
                        error: true,
                    }))


                resultadoValidacion = {
                    fechaValidacion: new Date(),
                    accionRealizada: "Actualizar oportunidad en anulación",
                    observacion: `No realizado, el servicio de actualizar no respondio`
                }
                let tomado = "Asesor Comercial";
                history = {
                    fechaHistory: new Date(),
                    tomado,
                    infoUsuario: userInfo,
                    resultadoValidacion,
                }

                saveHistoryEmpresas({ history, idFormulario })
            }
        } else if (actionsForm.includes("APROBAR_EJECUTIVO")) {
            stateReg = estados.APROBADA_CORPORATIVO;
            const resultAprobarEjec = true;//yield consumeActualizaOportunidad({ faseVenta: "Z23", anexos: false, itemsForm, nota: "Se aprobó la postulación para revision por ejecutivo comercial", idFormulario: false, estado: "2" });
            if (resultAprobarEjec) {
                procesoExitoso = true;
            }
        } else if (actionsForm.includes("APROBAR")) {
            stateReg = estados.APROBADA;
            const resultAprobar = yield consumeActualizaOportunidad({ faseVenta: "Z23", anexos: false, itemsForm, nota: "Se aprobó la postulación para revision por Rya", idFormulario: false, estado: "2" });
            if (resultAprobar) {
                procesoExitoso = true;
            }
        }
        if (procesoExitoso) {
            history = {
                fechaHistory: new Date(),
                tomado,
                infoUsuario: userInfo,
                resultadoValidacion,
            }

            if (actionsForm === "DEVOLVER") {
                const resDevolucion = {
                    motivo: data.datosdevolucion?.motivoDevolucion,
                    fecha: history.fechaHistory,
                    observacion: emptyObject(data.datosdevolucion?.observation),
                    user: userInfo
                }
                yield firebaseDatabase.collection(process.env.REACT_APP_FIREBASE_COLECCION_COMPANY)
                    .doc(idFormulario).set({ state: stateReg, devolucion: resDevolucion, ticketAfiliacion: false, date: resDevolucion.fecha }, { merge: true });

            } else if (actionsForm === "ANULAR") {
                const anulacion = {
                    fecha: history.fechaHistory,
                    motivo: resultadoValidacion.motivo,
                    observacion: emptyObject(resultadoValidacion.observacion),
                    user: userInfo
                }
                yield firebaseDatabase.collection(process.env.REACT_APP_FIREBASE_COLECCION_COMPANY)
                    .doc(idFormulario).set({ state: stateReg, anulacion, date: anulacion.fecha }, { merge: true });

            } else if (actionsForm === "APROBAR_EJECUTIVO") {
                const aprobacionEjecutivo = {
                    fecha: new Date(),
                    user: userInfo
                }
                yield firebaseDatabase.collection(process.env.REACT_APP_FIREBASE_COLECCION_COMPANY)
                    .doc(idFormulario).set({ state: stateReg, aprobacionEjecutivo, date: aprobacionEjecutivo.fecha }, { merge: true });

                const msgParametrizados = yield select(getMsgParametrizados);
                yield put(messageAlertSend(
                    {
                        message: yield generateMsgParametrizado(msgParametrizados, "msgAprobacionSuccess"),
                        error: false,
                        home: true
                    }))

                const suc_id = yield select(getSuc_id);
                yield obtenerDatosRegCompany({ suc_id });
            } else {
                const aprobacion = {
                    fecha: new Date(),
                    user: userInfo
                }
                yield firebaseDatabase.collection(process.env.REACT_APP_FIREBASE_COLECCION_COMPANY)
                    .doc(idFormulario).set({ state: stateReg, aprobacion, date: aprobacion.fecha }, { merge: true });

                const msgParametrizados = yield select(getMsgParametrizados);
                yield put(messageAlertSend(
                    {
                        message: yield generateMsgParametrizado(msgParametrizados, "msgAprobacionSuccess"),
                        error: false,
                        home: true
                    }))

                const suc_id = yield select(getSuc_id);
                yield obtenerDatosRegCompany({ suc_id });
            }
            saveHistoryEmpresas({ history, idFormulario })

            yield put(openModalCharged(false));

        } else {
            //No se pudo realizar algun proceso, sea DEVOLVER, ANULAR o APROBAR
            yield put(openModalCharged(false));

            const msgParametrizados = yield select(getMsgParametrizados);
            yield put(messageAlertSend(
                {
                    message: yield generateMsgParametrizado(msgParametrizados, "msgAprobacionFailure"),
                    error: true,
                }))
        }

    } catch (error) {
        console.error("Saga.savedActionsHistory", error);
        yield put(errorGeneral(manejoDeexepciones(error)));
    }
}




function* createBodyAfiliaCompany(action) {
    /*
función que realiza el mapeo de la información de la afilición y su posterior consumo del servicio que la registra
*/
    try {

        const { anexos, catalog, dataAfiliar, idFormulario } = action;

        const solicitudes = yield firebaseDatabase.collection(process.env.REACT_APP_FIREBASE_COLECCION_COMPANY).doc(idFormulario).get();
        const items = solicitudes.data();

        const inicio = items.step0.datosinicio;
        const personal = items.step1.datospersonaladmin;
        const empleador = items.step2.datosempleador;
        const caja = items.step2.ubicacionempleadorask;
        const ubicacion = items.step3.ubicacionempleador;
        const ubicacionAlter = items.step3.ubicacionempleadoralter;
        const ubicacionContact = items.step3.ubicacionempleadorcontact;
        const representante = items.step4.datosrepresentante;
        const afiliacion = items.stepPrincipal.afiliacionEmpresas;
        let dataRnec = items['dataRnec'] ? items['dataRnec'] : { representante: false, contacto: [] };
        const tiposSociedad = yield select(getDynamicOptions);

        const socitiTyypeAfil = afiliacion.empleadorTypeCompany === "1" ? parseInt(returnDataCatalog(tiposSociedad.societyType, dataAfiliar.datosrya.societyType, "label", "value")) : 9;
        const ip = yield call(axios.get, 'https://api.ipify.org?format=json');

        let personalAdmin = []

        if (personal && personal.length > 0) {
            for (var e of personal) {

                personalAdmin.push({
                    persona: {
                        "tipoIdentificacion": parseInt(returnDataCatalog(catalog.tiposId, e.typeIdStaff, "value", "id_tiid")),
                        "numeroIdentificacion": e.numberIdStaff,
                        "primerApellido": emptyObject(e.firstLastnameStaff),
                        "segundoApellido": emptyObject(e.secondLastnameStaff),
                        "primerNombre": emptyObject(e.firstNameStaff),
                        "segundoNombre": emptyObject(e.secondNameStaff),
                        "cargo": parseInt(returnDataCatalog(catalog.cargos, e.jobBossStaff, "label", "value")),
                        "correo": emptyObject(e.emailStaff),
                        "fechaNacimiento": getFechaOfDateRya(e.birthDateStaff),
                        "sexo": emptyObject(e.sexoStaff),
                        "estadoValidacion": dataRnecToAfiliacion(e.numberIdStaff, dataRnec.contacto, "contacto", "estadoValidacion"),
                        "fechaValidacion": dataRnecToAfiliacion(e.numberIdStaff, dataRnec.contacto, "contacto", "fechaValidacion"),
                        "fechaExpDocumento": dataRnecToAfiliacion(e.numberIdStaff, dataRnec.contacto, "contacto", "fechaExpedicion"),
                        "idMunicipio": yield returnDataCatalogV3(catalog.cities, dataRnecToAfiliacion(e.numberIdStaff, dataRnec.contacto, "contacto", "municipioExpedicion"), "label", "value"),
                    }
                })
            };
        }


        let anexosAfiliate = [];
        if (anexos && anexos.length > 0) {
            let anexosAfiliateAux = [];
            anexos.forEach(e => {
                const aux = e.doc.nombreArchivo.split(".");
                const idTiim = e.campo === "pdfFirmadoAdobe" ? 140 : parseInt(e.campo);
                anexosAfiliateAux.push({
                    "anexo": {
                        "idTiim": idTiim,
                        "base64Archivo": e.doc.contenidoArchivo,
                        "nombreArchivo": `${idTiim}.${aux[aux.length - 1]}`,
                        "isAnexo": e.campo === "pdfFirmadoAdobe" ? false : true,

                    }
                })
            });
            const pdfForm = anexosAfiliateAux.find(e => e.anexo.idTiim === 140);
            anexosAfiliate.push(pdfForm);
            anexosAfiliateAux.forEach(i => {
                if (i.anexo.idTiim !== 140)
                    anexosAfiliate.push(i)
            });

        }

        let body = {
            "requestMessageOut": {
                "header": {
                    "invokerDateTime": "2019-02-25 17:49:45",
                    "moduleId": "AFILIACIONEMPRESA",
                    "systemId": "SIRAP",
                    "messageId": "AFILIACIONEMPRESA|123456789",
                    "logginData": {
                        "sourceSystemId": "",
                        "destinationSystemId": ""
                    },
                    "destination": {
                        "namespace": "http://co/com/comfenalcovalle/esb/ws/RegistrarAfiliacionEmpresa",
                        "name": "HCPRegistrarAfiliacionEmpresa",
                        "operation": "execute"
                    },
                    "securityCredential": {
                        "userName": "",
                        "userToken": ""
                    },
                    "classification": {
                        "classification": ""
                    }
                },
                "body": {
                    "request": {
                        "registrarAfilicionEmpresaRequest": {
                            "formularioEmpresa": {
                                "opcion": "AFILIAR",
                                "tipoSociedad": socitiTyypeAfil,
                                "idDocu": items.idDocu,
                                "tipoEmpleador": parseInt(afiliacion.empleadorTypeCompany),
                                "tipoIdentificacion": parseInt(returnDataCatalog(catalog.tiposId, inicio.typeIdCompanyStart, "value", "id_tiid")),
                                "numeroIdentificacion": inicio.checkNumberStart,
                                "digitoVerificacion": empleador.digitNumber,
                                "nombreEmpleador": empleador.employerName,
                                "correo": empleador.emailCompany,
                                "numeroEmpleados": parseInt(empleador.employedNumber),
                                "idRegionalSede": inicio.sedeRegional === "0" ? 1 : parseInt(inicio.sedeRegional),
                                "idUsuaAsesor": 4001,
                                "direccionIp": `${emptyObject(ip.data?.ip)}`,
                                "personalAdministrativo": personalAdmin,
                                "claseEmpresa": parseInt(emptyObject(empleador.companyClass)),
                                "actividadEconomica": returnDataCatalog(catalog.actividad, empleador.economicActivity, "label", "value"),
                                "fechaInicioOperacion": empleador.startOperation ? getFechaOfDateRya(empleador.startOperation) : "0000-00-00",
                                "fechaMatriculaMercantil": items.fechaMatriculaMercantil ? items.fechaMatriculaMercantil : "0000-00-00",
                                "valorNominaMes": convNumFormat(empleador.payrollMonth),
                                "primerPeriodoAportes": empleador.contributionPeriod ? getFechaOfDateYearMonth(empleador.contributionPeriod) : "",
                                "afiliadoCaja": caja.empleadorCajaAsk === "2" ? false : true,
                                "nombreCaja": caja.empleadorCajaAsk === "2" ? "" : caja.empleadorCajaRta,
                                "idDepto": parseInt(returnDataCatalog(catalog.deptos, ubicacion.departamentCompany, "label", "value")),
                                "idMuni": parseInt(returnDataCatalog(catalog.cities, ubicacion.cityCompany, "label", "value")),
                                "idBarrio": parseInt(returnDataCatalog(catalog.barrios, ubicacion.hoodCompany, "label", "value")),
                                "direccion": ubicacion.addressCompany,
                                "idDeptoAlterno": ubicacionAlter && ubicacionAlter.departamentCompanyAlternate ? parseInt(returnDataCatalog(catalog.deptos, ubicacionAlter.departamentCompanyAlternate, "label", "value")) : 0,
                                "idMuniAlterno": ubicacionAlter && ubicacionAlter.cityCompanyAlternate ? parseInt(returnDataCatalog(catalog.cities, ubicacionAlter.cityCompanyAlternate, "label", "value")) : 0,
                                "idBarrioAlterno": ubicacionAlter && ubicacionAlter.hoodCompanyAlternate ? parseInt(returnDataCatalog(catalog.barrios, ubicacionAlter.hoodCompanyAlternate, "label", "value")) : 0,
                                "direccionAlterno": ubicacionAlter ? emptyObject(ubicacionAlter.addressCompanyAlternate) : "",
                                "telefonoFijo": emptyObject(ubicacionContact.phoneCompany),
                                "telefonoCelular": ubicacionContact.smartPhoneCompany,
                                "paginaWeb": emptyObject(ubicacionContact.webSite),
                                "anexos": anexosAfiliate,
                                "representanteLegal": {
                                    "tipoIdentificacion": parseInt(returnDataCatalog(catalog.tiposId, representante.typeId, "value", "id_tiid")),
                                    "numeroIdentificacion": representante.numberId,
                                    "primerApellido": emptyObject(representante.firstLastname),
                                    "segundoApellido": emptyObject(representante.secondLastname),
                                    "primerNombre": emptyObject(representante.firstName),
                                    "segundoNombre": emptyObject(representante.secondName),
                                    "cargo": parseInt(returnDataCatalog(catalog.cargos, representante.jobBoss, "label", "value")),
                                    "correo": emptyObject(representante.emailJobBoss),
                                    "sexo": emptyObject(representante.sexo),
                                    "fechaNacimiento": getFechaOfDateRya(representante.birthDate),
                                    "celular": emptyObject(representante.smartPhoneBoss),
                                    "estadoValidacion": dataRnecToAfiliacion(null, dataRnec.representante, "representante", "estadoValidacion"),
                                    "fechaValidacion": dataRnecToAfiliacion(null, dataRnec.representante, "representante", "fechaValidacion"),
                                    "fechaExpDocumento": dataRnecToAfiliacion(null, dataRnec.representante, "representante", "fechaExpedicion"),
                                    "idMunicipio": yield returnDataCatalogV3(catalog.cities, dataRnecToAfiliacion(null, dataRnec.representante, "representante", "municipioExpedicion"), "label", "value"),

                                }

                            }
                        }
                    }
                }
            }
        }
        return body;

    } catch (error) {
        console.error("Saga.createBodyAfiliaCompany", error);
        throw error;
    }
}

function* sendGrabaAfiliacion(action) {
    try {
        const { bodyRequest, idFormulario } = action;
        const url = process.env.REACT_APP_FIREBASE_SEND_GRABA_AFILIACION;

        let body = { idFormulario, body: bodyRequest, urlServicio: process.env.REACT_APP_URL_COMFENALCO_GRABA_AFILIACION }
        //let body = { idFormulario, body: bodyRequest, urlServicio: "https://pruebas.comfenalcovalle.com.co/esb/RESTJSONChannelAdapter" }
        const headers = HEADERS_WS;
        const respues = yield call(axios.post, url, body, headers);
        return respues;
    } catch (error) {
        console.error("Function.sendGrabaAfiliacion", error);
        throw error;
    }

}

function* searchHistorialform(action) {
    /*
función consulta el historial de una afiliacion y crea el json con la informacion a mostrar
*/
    const { value } = action;

    try {
        let resultadoConsulta = []
        const reference = yield firebaseDatabase.collection(process.env.REACT_APP_FIREBASE_COLECCION_COMPANY).doc(value).collection("history")
            .orderBy('fechaHistory', 'asc')
            .get();
        reference.docs.map((doc, i) => {
            resultadoConsulta.push(doc.data())
        });
        let historico = []
        if (resultadoConsulta.length > 0) {
            resultadoConsulta.forEach(e => {
                historico.push({
                    date: convertirFecha(e.fechaHistory),
                    name: emptyObject(e.infoUsuario.nameCompleted),
                    tomado: emptyObject(e.tomado),
                    rol: emptyObject(e.infoUsuario.rol),
                    email: emptyObject(e.infoUsuario.email),
                    action: emptyObject(e.resultadoValidacion.accionRealizada),
                    motivo: emptyObject(e.resultadoValidacion.motivo),
                    observation: emptyObject(e.resultadoValidacion.observacion ? e.resultadoValidacion.observacion : e.resultadoValidacion.observation ? e.resultadoValidacion.observacion : ""),
                    refFile: emptyObject(e.resultadoValidacion.refFil)
                })
            });

            yield put(openHistoryBandeja(historico));
        }
    } catch (error) {
        console.error("Saga.savedActionsHistory", error);
        yield put(errorGeneral(manejoDeexepciones(error)));
    }


}

function* buildDynamicOptions(action) {
    try {
        const { userType } = action;
        let dynamicOptions = {};



        if (userType === "rya") {
            const devoluciones = yield getAsyncCatalog('MOTIVOS_DEVOLUCION');
            const sociedad = yield getAsyncCatalog('TIPOS_SOCIEDAD');
            const anulacion = yield getAsyncCatalog('MOTIVOS_ANULACION');
            dynamicOptions.motivoAnulacionForm = anulacion.sort(ordenar);
            dynamicOptions.societyType = sociedad.sort(ordenar);
            dynamicOptions.motivoDevolucion = devoluciones.sort(ordenar);

        } else if (userType === "informes") {
            const stateAfilia = yield getAsyncCatalog('ESTADOS_AFILIACION');
            let estados = ["TODOS"];
            stateAfilia.forEach(e => {
                estados.push(e.label)
            });
            dynamicOptions.stateAfilia = estados;
            dynamicOptions.states = stateAfilia;

        }
        else {
            const devoluciones = yield getAsyncCatalog('MOTIVOS_DEVOLUCION');
            const anulacion = yield getAsyncCatalog('MOTIVOS_ANULACION');
            dynamicOptions.motivoAnulacion = anulacion.sort(ordenar);
            dynamicOptions.motivoDevolucion = devoluciones.sort(ordenar);
        }

        const res = yield put(loadDocumentSuccess(dynamicOptions));

    } catch (error) {
        console.error("Function.buildDynamicOptions", error);
        throw error;
    }
}

function* recoveryTableAfiliations() {
    try {
        const suc_id = yield select(getSuc_id);
        yield obtenerDatosRegCompany({ suc_id });
    } catch (error) {
        console.error("Function.recoveryTableAfiliations", error);
        yield put(errorGeneral(manejoDeexepciones(error)));
    }
}

function* obtenerDatosReports(action, limit = 10) {
    try {
        const { body } = action;
        let request = body;
        let reference = yield cosumeConsultaBigquery({ body: request });
        //vamos a consultar los primeros 10 registros de empresas
        let resultadoConsulta = []
        if (reference && reference.rows)
            reference.rows.map((doc, i) => {
                resultadoConsulta.push(doc)
            });

        if (resultadoConsulta.length > 0) {

            //     const dataFinal = resultadoConsulta;

            let data = yield crearDataTable({ data: resultadoConsulta, coleccion: "reportsCompany" });

            yield put(setDataPaginarReportsEmpresas(
                {
                    "dataReportsCompany": data,
                    "esPrimeraPagina": true,
                    "totalConsulta": reference.total
                }
            ));
        } else {
            // no hay afiliaciones registradas para el filtro
            yield put(setDataPaginarReportsEmpresas(
                {
                    "dataReportsCompany": [],
                    "esPrimeraPagina": true,
                    "totalConsulta": false
                }
            ));
        }
        yield put(openModalCharged(false));

    } catch (error) {
        console.error('saga.obtenerDatosRegCompany', error);
        yield put(errorGeneral(manejoDeexepciones(error)));
    }
}

function* obtenerDatosReportsToDowload(action, limit = 10) {
    try {
        const { body } = action;
        let request = body;
        let reference = yield cosumeConsultaBigquery({ body: request });
        //vamos a consultar los primeros 10 registros de empresas
        let resultadoConsulta = []
        if (reference && reference.rows)
            reference.rows.map((doc, i) => {
                resultadoConsulta.push(doc)
            });

        if (resultadoConsulta.length > 0) {

            //     const dataFinal = resultadoConsulta;

            let data = yield crearDataTable({ data: resultadoConsulta, coleccion: "reportsCompany" });

            return data;
        } else {
            // no hay afiliaciones registradas para el filtro
            return false;
        }


    } catch (error) {
        console.error('saga.obtenerDatosRegCompany', error);
        yield put(errorGeneral(manejoDeexepciones(error)));
    }
}

function* paginarDataReports(action) {
    try {

        const { first, rows } = action.value.event;
        const { ultimaConv, nextPage } = action.value;

        let consulta = yield select(getConsultaReports);


        consulta.limit = rows;
        if (nextPage) {
            consulta.page = consulta.page + rows;
        } else {
            if (rows > 10) {
                consulta.page = 0;
            } else if (consulta.page > 0) {
                consulta.page = consulta.page - 10;
            }

        }


        yield obtenerDatosReports({ body: consulta, esPrimera: false })

    } catch (error) {
        console.error("saga.paginarDataRegCompany", error);
        yield put(errorGeneral(manejoDeexepciones(error)));
    }

}

function* openReportCompletion(action) {
    try {
        const { value: { numDocBD } } = action;
        yield put(openFormBandeja({ state: true, idForm: numDocBD }));
        const userInfo = yield select(getUserInfo);
        const userType = yield select(getUserType);
        yield buildDynamicOptions({ userType });
        const history = {
            fechaHistory: new Date(),
            tomado: userInfo.rol,
            infoUsuario: userInfo,
            resultadoValidacion: {
                fechaValidacion: new Date(),
                accionRealizada: "Revisado por asesor"
            },
        }
        saveHistoryEmpresas({ history, idFormulario: numDocBD })
        if (userType === "comercial" || userType === "asesor")
            yield firebaseDatabase.collection(process.env.REACT_APP_FIREBASE_COLECCION_COMPANY)
                .doc(numDocBD).set({ state: estados.VALIDACION_COMERCIAL, dateValidation: history.fechaHistory, date: history.fechaHistory }, { merge: true });
        else
            yield firebaseDatabase.collection(process.env.REACT_APP_FIREBASE_COLECCION_COMPANY)
                .doc(numDocBD).set({ state: estados.VALIDACION_RYA, dateValidation: history.fechaHistory, date: history.fechaHistory }, { merge: true });

    } catch (error) {
        console.error('saga.searchFormFromTable', error);
        yield put(errorGeneral(manejoDeexepciones(error)));
    }
}

function* initFilterReports(action) {
    try {
        yield put(openModalCharged(true));
        const values = yield select(getFormValuesFilter)
        const catalog = yield select(getDynamicOptions)
        const stados = catalog.states;

        //yield put(initialize(REPORTS_FORM_NAME, { informesCompanys: {} }));
        if (values !== undefined && values && values.informesCompanys) {
            let body = {}
            if (values.informesCompanys.dateStart) {
                if (values.informesCompanys.dateEnd) {
                    body = {
                        dateStart: values.informesCompanys.dateStart,
                        dateEnd: values.informesCompanys.dateEnd,
                        state: "",
                        page: 0,
                        limit: 10,
                        selectType: "date"
                    }
                    if (values.informesCompanys.stateAfilia) {
                        body.state = createState(values.informesCompanys.stateAfilia, stados);
                    }
                    yield obtenerDatosReports({ body, esPrimera: true })
                    yield put(saveConsultaReports(body))
                } else {
                    // debe haber fecha final
                    yield put(openModalCharged(false));

                    yield put(messageAlertSend(
                        {
                            message: "Para consultar información por rango de fecha, debes ingresar la fecha inicial seguida de la fecha final.",
                            error: true,
                        }));

                }
            }
            else if (values.informesCompanys.idCompanyReport) {
                // filtrar por identificacion
                body = {
                    idCompany: values.informesCompanys.idCompanyReport,
                    selectType: "id"
                }
                yield obtenerDatosReports({ body })
                yield put(saveConsultaReports(body))
            }
            else if (values.informesCompanys.idOportunidadReport) {
                // filtrar por oportunidad
                body = {
                    idOportunidad: values.informesCompanys.idOportunidadReport,
                    selectType: "oportunidad"
                }
                yield obtenerDatosReports({ body })
                yield put(saveConsultaReports(body))
            }
            else if (values.informesCompanys.idDocuReport) {
                // filtrar por oportunidad
                body = {
                    idDocu: values.informesCompanys.idDocuReport,
                    selectType: "idDocu"
                }
                yield obtenerDatosReports({ body })
                yield put(saveConsultaReports(body))
            } else {
                yield put(openModalCharged(false));
                yield put(messageAlertSend(
                    {
                        message: "Antes de iniciar la consulta de información debe ingresar algun valor o combinación de valores valida par la consulta.",
                        error: true,
                    }));
            }


        } else {
            //no ha llenado ningun valor 
            yield put(openModalCharged(false));
            yield put(messageAlertSend(
                {
                    message: "Antes de iniciar la consulta de información debe ingresar mínimo un valor de busqueda.",
                    error: true,
                }));
        }

    } catch (error) {
        yield put(errorGeneral(manejoDeexepciones(error)));
    }
}

function* openComponentInformes(action) {
    try {
        yield put(initOpenComponentReports(true));
        yield buildDynamicOptions({ userType: "informes" })

    } catch (error) {
        yield put(errorGeneral(manejoDeexepciones(error)));
    }
}

function* openModalDescargarDatos(action) {
    try {
        const { value } = action;
        const idForm = value.idFirebase;
        //Se descarga toda la info del seleccionado 
        let dataSelect = {
            big: value,
            info: "",
            history: []
        };
        const solicitudes = yield firebaseDatabase.collection(process.env.REACT_APP_FIREBASE_COLECCION_COMPANY)
            .doc(idForm)
            .get();

        if (solicitudes.data()) {
            dataSelect.info = solicitudes.data();
            let historico = []
            // se descarga el historial y se envia
            yield firebaseDatabase.collection(process.env.REACT_APP_FIREBASE_COLECCION_COMPANY)
                .doc(idForm).collection("history")
                .orderBy('fechaHistory', 'asc')
                .get().then(response => {
                    response.docs.map((doc, i) => {
                        historico.push(doc.data());
                    });
                });

            const catalog = yield select(getDynamicOptions);
            dataSelect.info.stepPrincipal.afiliacionEmpresas.empleadorTypeCompanyName = emptyObject(dataSelect.info.stepPrincipal.afiliacionEmpresas.empleadorTypeCompany) === "1" ? "Persona Jurídica" : emptyObject(dataSelect.info.stepPrincipal.afiliacionEmpresas.empleadorTypeCompany) === "2" ? "Persona Natural" : "Servicio Doméstico";
            dataSelect.info.step0.datosinicio.sedeRegionalName = returnDataCatalog(catalog.sedes, dataSelect.info.step0.datosinicio.sedeRegional, "value", "label");

            if (historico.length > 0) {
                historico.forEach(e => {
                    dataSelect.history.push({
                        date: convertirFecha(e.fechaHistory),
                        name: emptyObject(e.infoUsuario.nameCompleted),
                        tomado: emptyObject(e.tomado),
                        rol: emptyObject(e.infoUsuario.rol),
                        email: emptyObject(e.infoUsuario.email),
                        action: emptyObject(e.resultadoValidacion.accionRealizada),
                        motivo: emptyObject(e.resultadoValidacion.motivo),
                        observation: emptyObject(e.resultadoValidacion.observacion ? e.resultadoValidacion.observacion : e.resultadoValidacion.observation ? e.resultadoValidacion.observacion : ""),
                        refFile: emptyObject(e.resultadoValidacion.refFil)
                    })
                });
            }

            yield put(dataModalDescarDatos(dataSelect))


        } else {
            yield put(openModalCharged(false));

            const msgParametrizados = yield select(getMsgParametrizados);
            yield put(messageAlertSend(
                {
                    message: yield generateMsgParametrizado(msgParametrizados, "msgRegiDownloadNotBD"),
                    error: true,
                }));

        }
    } catch (error) {
        yield put(errorGeneral(manejoDeexepciones(error)));
    }
}

function* downloadCsvDataAfiliationsReports(action) {
    try {
        const { value } = action;
        const jsonToExcel = [];
        yield put(openModalCharged(true));
        let consulta = yield select(getConsultaReports);
        console.log(consulta, value)
        consulta.page = 0;
        consulta.limit = yield select(getTotalConsultaReports);
        const dataToDownloadCsv = consulta.selectType === "date" ? yield obtenerDatosReportsToDowload({ body: consulta }) : value.dataToDownloadCsv;

        if (dataToDownloadCsv.length > 0) {

            let header = [];
            HEADER_TABLE_PAGINATOR_REPORTS.forEach(e => {
                header.push(e.header)
            });

            dataToDownloadCsv.forEach(e => {
                let aux = e;
                delete aux["idFirebase"];
                jsonToExcel.push(aux)
            });

            XlsxPopulate.fromBlankAsync().then(async (workbook) => {
                const sheet1 = workbook.sheet(0);
                const sheetData = getSheetData(jsonToExcel, header);
                const totalColumns = 26//sheetData[0].length;                
                sheet1.cell("A1").value(sheetData);
                const range = sheet1.usedRange();
                const endColumn = String.fromCharCode(64 + totalColumns);
                sheet1.row(1).style("bold", true);
                sheet1.range("A1:" + endColumn + "1").style("fill", "BFBFBF");
                range.style("border", true);

                return workbook.outputAsync().then((res) => {
                    saveAs(res, "ReportsInscripcionesEmpresas.xlsx");
                });
            }).catch((err) => {
                throw err;
            })

        }
        yield put(openModalCharged(false));

    } catch (error) {
        yield put(errorGeneral(manejoDeexepciones(error)));
    }
}

function* actionsAnulationsForm(action) {
    try {
        const { value } = action;
        console.log(action);
        const catalog = yield select(getDynamicOptions);
        console.log(catalog);
        // if (!(catalog && catalog.states)) {
        //     const userType = yield select(getUserType);
        //     yield buildDynamicOptions({ userType });
        // }

        if (value.type === "search") {
            let solicitudes = false;
            let idFormulario = false;
            const idOportunidad = yield select(getFormValuesAnulationForm);
            if (idOportunidad && idOportunidad.datosFormAnulation && idOportunidad.datosFormAnulation.oportunidadNumber) {
                yield put(openModalCharged(true));
                yield firebaseDatabase.collection("solicitudesEmpresas")
                    .where('idOportunidad', '==', idOportunidad.datosFormAnulation.oportunidadNumber)
                    //.where('state', 'not-in', [estados.ANULADA, estados.AFILIADA])
                    .get().then(docs => {
                        docs.forEach(doc => {
                            console.log(doc)
                            if (doc.data()) {
                                solicitudes = doc.data();
                                solicitudes.idFormulario = doc.id;
                                //console.log(solicitudes)
                            }
                        });
                    });

                // console.log(solicitudes)
                if (solicitudes && solicitudes.idFormulario) {
                    if (solicitudes.state && !(solicitudes.state === 4 || solicitudes.state === 9)) {
                        if (catalog && catalog.states) {
                            const stateLabel = catalog.states.find(e => e.value === solicitudes.state);
                            if (stateLabel !== undefined && stateLabel.label) {
                                solicitudes.stateLabel = stateLabel.label;
                            }
                        }
                        yield put(dataAnulationForm(solicitudes))
                    } else {
                        yield put(messageAnulationFormRya(
                            {
                                message: "La oportunidad ingresada para la solicitud de afiliacion, no se encuentra en un estado valido para anular.",
                                error: true,
                                home: true
                            }))
                    }
                } else {
                    yield put(messageAnulationFormRya(
                        {
                            message: "El número de oportunidad ingresado, no arroja resultados. Por favor verifique e intentelo nuevamente.",
                            error: true,
                            home: true
                        }))
                }
            } else {
                yield put(messageAnulationFormRya(
                    {
                        message: "Es necesario ingresar un número de opotunidad para continuar con la busqueda.",
                        error: true,
                        home: true
                    }))
            }
        }
        // yield put(openModalCharged(true));


        if (value.type === "anular" || value.type === "validaAnular") {
            yield put(messageAnulationFormRya(false))
            const userInfo = yield select(getUserInfo);
            const datas = yield select(getDataAnulationForm);
            const motivo = yield select(getFormValuesAnulacionFormMotivo);
            if (validateAnularV2Form(motivo)) {
                if (value.type === "validaAnular") {
                    const datas = yield select(getDataAnulationForm);
                    yield put(messageAnulationFormRya(
                        {
                            message: `Esta seguro de anular la solicitud relacionada con el número de oportunidad: ${datas.idOportunidad}`,
                            error: false,
                            confirma: true,
                        }));

                } else {
                    yield put(openModalCharged(true));
                    let history = {
                    }
                    let resultadoValidacion = {
                        fechaValidacion: new Date(),
                        accionRealizada: "Anular solicitud",
                        tomado: "Asesor rya",
                        motivo: motivo.datosanulacionform?.motivoAnulacionForm,
                        observacion: emptyObject(motivo.datosanulacionform?.observationAnulationForm)
                    }



                    const catalog = yield select(getDynamicOptions);
                    console.log(catalog);
                    const idMotivo = yield retornaIdCatalog(catalog.motivoAnulacionForm, resultadoValidacion.motivo);
                    const nota = `Información anulación o rechazo\n\nObservacion: ${emptyObject(resultadoValidacion.observacion)} \nMotivo: ${emptyObject(resultadoValidacion.motivo)}`;
                    const resultAnular = yield consumeActualizaOportunidad({ faseVenta: "Z94", idMotivo, anexos: false, itemsForm: datas, nota, idFormulario: false, estado: "5" });
                    if (resultAnular) {
                        if (datas.ticketAfiliacion) {
                            const resulTicket = yield consumeActualizaTicket({ estadoTicket: "Z7", itemsForm: datas, nota: "Cerrado por anulación", idFormulario: datas.idFormulario });
                            if (resulTicket) {
                                const anulacion = {
                                    fecha: resultadoValidacion.fechaValidacion,
                                    motivo: resultadoValidacion.motivo,
                                    observacion: emptyObject(resultadoValidacion.observacion),
                                    user: userInfo
                                }
                                yield firebaseDatabase.collection(process.env.REACT_APP_FIREBASE_COLECCION_COMPANY)
                                    .doc(datas.idFormulario).set({ state: estados.ANULADA, anulacion, date: anulacion.fecha }, { merge: true });

                                const msgParametrizados = yield select(getMsgParametrizados);
                                yield put(messageAnulationFormRya(
                                    {
                                        message: yield generateMsgParametrizado(msgParametrizados, "msgAnulaSuccess"),
                                        error: false,
                                        home: true
                                    }))

                                yield put(initialize(FORM_NAME_ANULATION_FORM, {}));
                                yield put(dataAnulationForm(false))

                            } else {
                                yield put(openModalCharged(false));

                                const msgParametrizados = yield select(getMsgParametrizados);
                                yield put(messageAnulationFormRya(
                                    {
                                        message: yield generateMsgParametrizado(msgParametrizados, "msgAnulaFailure"),
                                        error: true,
                                    }))


                                resultadoValidacion = {
                                    fechaValidacion: new Date(),
                                    accionRealizada: "Actualizar ticket en anulación",
                                    observacion: `No realizado, sin respuesta`
                                }
                                let tomado = "Asesor Rya";
                                history = {
                                    fechaHistory: new Date(),
                                    tomado,
                                    infoUsuario: userInfo,
                                    resultadoValidacion,
                                }

                                saveHistoryEmpresas({ history, idFormulario: datas.idFormulario })
                            }
                        } else {
                            const msgParametrizados = yield select(getMsgParametrizados);
                            yield put(messageAnulationFormRya(
                                {
                                    message: yield generateMsgParametrizado(msgParametrizados, "msgAnulaSuccess"),
                                    error: false,
                                    home: true
                                }))

                            yield put(initialize(FORM_NAME_ANULATION_FORM, {}));
                            yield put(dataAnulationForm(false));
                        }
                    } else {
                        yield put(openModalCharged(false));
                        const msgParametrizados = yield select(getMsgParametrizados);
                        yield put(messageAnulationFormRya(
                            {
                                message: yield generateMsgParametrizado(msgParametrizados, "msgAnulaFailure"),
                                error: true,
                            }))


                        resultadoValidacion = {
                            fechaValidacion: new Date(),
                            accionRealizada: "Actualizar oportunidad en anulación",
                            observacion: `No realizado, el servicio de actualizar no respondio`
                        }
                        let tomado = "Asesor Rya";
                        history = {
                            fechaHistory: new Date(),
                            tomado,
                            infoUsuario: userInfo,
                            resultadoValidacion,
                        }

                        saveHistoryEmpresas({ history, idFormulario: datas.idFormulario })
                    }
                }

            } else {
                // debe ingresar un motivo valido
                console.log("Error")
                yield put(messageAnulationFormRya(
                    {
                        message: "Debe diligenciar los datos de la anulación antes de continuar",
                        error: true,
                    }));
            }


        }

        if (value.type === "clear") {
            yield put(initialize(FORM_NAME_ANULATION_FORM, {}));
            yield put(dataAnulationForm(false))
        }
        yield put(openModalCharged(false));

    } catch (error) {
        yield put(errorGeneral(manejoDeexepciones(error)));
    }
}

function* onOpenAnulationForm(action) {
    try {

        let dynamicOptions = yield select(getDynamicOptions);


        if (!(dynamicOptions && dynamicOptions.motivoAnulacionForm)) {
            const stateAfilia = yield getAsyncCatalog('ESTADOS_AFILIACION');
            const anulacion = yield getAsyncCatalog('MOTIVOS_ANULACION');
            dynamicOptions.motivoAnulacionForm = anulacion.sort(ordenar);
            dynamicOptions.states = stateAfilia;


            const res = yield put(loadDocumentSuccess(dynamicOptions));
        }
    } catch (error) {
        console.error("Function.onOpenAnulationForm", error);
        throw error;
    }
}

function* searchUser() {
    try {
        const authUser = getFromSession('authUserColaborador');
        const authUserColaborador = getFromSession('authUserFinished');
        // console.log(authUser, authUserColaborador)
        if (authUserColaborador) {
            return authUserColaborador;
        } else {
            if (authUser && authUser.user) {
                return yield consumeEnpoint({ app_id: process.env.REACT_APP_ID_COLABORADOR_FIREBASE, token: authUser.user.token, bearer: authUser.user.accessToken });
                //return yield select(getFirebaseUserInfo)
            }
        }
    } catch (error) {
        console.error("saga.searchUser", error);
    }
}

function* consumeEnpoint(action) {
    /* Función que recibe el documento y tipo de documento del afiliado
        y consulta el validador de derechos y retorna la información del afiliado+
     */
    const { app_id, token, bearer } = action;

    const urlEnpoint = process.env.REACT_APP_URL_COMFENALCO_API_COLABORADOR_FIREBASE;

    let headers = {
        "Access-Control-Allow-Credentials": "true",
        "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE, OPTIONS",
        "Access-Control-Allow-Origin": "*",
        "Authorization": 'Bearer ' + bearer,
        'Content-Type': 'application/json'

    };

    const body = {
        app_id,
        token
    }
    // console.log(JSON.stringify(body));

    var resul = false;
    try {

        const res = yield call(axios.post, urlEnpoint, body, { headers });

        if (res.data.idToken)
            resul = res.data.idToken;

        return resul;
    } catch (error) {
        console.error("exception: ", error)
        return error;
    }
}

export function* watchUsers() {
    yield takeLatest(PAGINAR_DATA_REG_EMPRESAS, paginarDataRegCompany);
    yield takeLatest(OBTENER_DATA_REG_EMPRESAS, obtenerDatosRegCompany);
    yield takeLatest(SEARCH_FORM_FROM_TABLE, searchFormFromTable);
    yield takeLatest(VALIDATE_USER_TYPE, initValidateUser);
    yield takeLatest(INIT_CHARGE_CATALOG, getUserRols);
    yield takeLatest(REDUX_BLUR, onreduxBlur);
    yield takeLatest(REDUX_CHANGE, onReduxChange);
    yield takeLatest(ACTIONS_OF_APROVE, onActionsAprove);
    yield takeLatest(ACTIONS_ON_AFILIATE_RYA, onActionsAproveRya);
    yield takeLatest(ACTION_AFILIATE_COMPANY, actionsCompanyRya);
    yield takeLatest(SAVED_ACTIONS_VALIDATION, savedActionsHistory);
    yield takeLatest(SEARCH_HISTORIAL_BANDEJA, searchHistorialform);
    yield takeLatest(RETURN_HOME_BANDEJA, recoveryTableAfiliations)
    yield takeLatest(EXPORT_DATA_FORM_XLSX, exportIntentToExcel);
    yield takeLatest(PAGINAR_DATA_REPORTS, paginarDataReports);
    yield takeLatest(OBTENER_DATA_REPORTS, obtenerDatosReports);
    yield takeLatest(OPEN_REPORT_COMPLETION, openReportCompletion);
    yield takeLatest(INIT_SEARCH_FILTER_REPORT, initFilterReports);
    yield takeLatest(OPEN_COMPONENT_INFORMES, openComponentInformes);
    yield takeLatest(OPEN_MODAL_DESCARGAR_DATOS, openModalDescargarDatos);
    yield takeLatest(DOWMLOAD_DATA_TABLE_AFILIATIONS, downloadCsvDataAfiliationsReports);
    yield takeLatest(ACTION_ANULATION_FORM, actionsAnulationsForm);
    yield takeLatest(OPEN_ANULATION_FORM, onOpenAnulationForm)
}